<template>
  <v-container fluid style="padding:0">
      <v-form :disabled="readonly" ref="iniform" v-model="iniValidInt">
        <v-row v-if="!infValid(0)" no-gutters>
            <v-col cols="12">
                <div :class="'v-messages theme--dark ' + ( readonly ? '' : 'error--text')" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message">*Infusion Required to QA/Complete</div></div></div>
            </v-col>
        </v-row>
        <div v-for="(inf, infind) in iniVal.entries.inf" :style="(inf.duplicate || inf.invalid_push ? 'border: solid 2px #ff5252;min-height: 158px;margin-bottom: 16px;' :'')" :key="'inf_' + infind">
            <v-row v-if="inf.duplicate" style="margin-bottom:-5px" no-gutters class>
                <v-col style="padding:0; background-color:#ff5252;" cols="12">
                    <h3 style="color:white; text-align:center; font-style:italic;">THIS IS A DUPLICATE ENTRY AND WILL NOT BE CALCULATED!</h3>
                </v-col>
            </v-row>
            <v-row v-else-if="inf.invalid_push" style="margin-bottom:-5px" no-gutters class>
                <v-col style="padding:0; background-color:#ff5252;" cols="12">
                    <h3 style="color:white; text-align:center; font-style:italic;">INVALID PUSH - MUST BE SAME SYRINGE OR DIFFERENT STARTS</h3>
                </v-col>
            </v-row>
            <v-row v-else-if="inf.invalid_push_soft" style="margin-bottom:-5px" no-gutters class>
                <v-col style="padding:0; background-color:#ffa545;" cols="12">
                    <h3 style="color:white; text-align:center; font-style:italic;">NOTE - PUSH WITH SAME SITE SAME START</h3>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col style="padding:0" cols="11">
                    <v-row no-gutters style="height:40px;margin-top:5px;">
                        <v-col cols="5">
                            <v-select
                                class="demofields"
                                dense
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'Type: ' + iniQaVal.entries.inf[infind].type + (iniQaVal.entries.inf[infind].type == inf.type ? ' - ✓' : ' - ✗' ) : 'Type')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                style="font-weight:bold;"
                                v-model="inf.type"
                                :rules="fieldRuleDep(inf.type,'inf_type',inf.drug)"
                                @input="iniCalc"
                                outlined
                                :items="infType"
                            ></v-select>
                        </v-col>
                        <v-col cols="5">
                            <v-select
                                class="demofields"
                                dense
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'Site: ' + iniQaVal.entries.inf[infind].site + (iniQaVal.entries.inf[infind].site == inf.site ? ' - ✓' : ' - ✗' ) : 'Site')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                v-model="inf.site"
                                :rules="fieldRuleDep(inf.site,'inf_site',inf.drug)"
                                @input="iniCalc"
                                outlined
                                :items="ivSites"
                            ></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-select
                                class="demofields"
                                dense
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'Dept: ' + iniQaVal.entries.inf[infind].department + (iniQaVal.entries.inf[infind].department == inf.department ? ' - ✓' : ' - ✗' ) : 'Department')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                v-model="inf.department"
                                :rules="fieldRule(inf.department,'inf_department')"
                                @input="iniCalc"
                                outlined
                                :readonly="facSettings.ini_settings.ro_department"
                                :items="departments"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row v-if="inf.type.toLowerCase().includes('hydration')" no-gutters style="height:40px;margin-top:0px;">
                        <v-col cols="12">
                            <v-combobox
                                class="demofields"
                                dense
                                clearable
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'Drug: ' + iniQaVal.entries.inf[infind].drug + (iniQaVal.entries.inf[infind].drug == inf.drug ? ' - ✓' : ' - ✗' ) : 'Drug')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                v-model="inf.drug"
                                :rules="fieldRuleDep(inf.drug,'drug',inf.drug)"
                                outlined
                                @input="iniCalc();forceFormValidate('iniform');"
                                :items=iniRXSimple
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row v-else no-gutters style="height:40px;margin-top:0px;">
                        <v-text-field
                            v-show="false"
                            dense
                            outlined
                            :rules="fieldRuleInd(inf.drug,'inf_drug',infind)"
                            @input="iniCalc"
                            v-model="inf.drug"
                        ></v-text-field>
                        <v-col cols="6">
                            <v-combobox
                                class="demofields"
                                dense
                                clearable
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'Drug 1: ' + iniQaVal.entries.inf[infind].drug1 + (iniQaVal.entries.inf[infind].drug1 == inf.drug1 ? ' - ✓' : ' - ✗' ) : 'Drug 1')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                v-model="inf.drug1"
                                @input="inf.drug = combiDrug(inf.drug1,inf.drug2); iniCalc();forceFormValidate('iniform');"
                                :rules="fieldRuleDep(inf.drug1,'drug',inf.drug1)"
                                outlined
                                :items=iniRXSimple
                            ></v-combobox>
                        </v-col>
                        <v-col cols="6">
                            <v-combobox
                                class="demofields"
                                dense
                                clearable
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'Drug 2: ' + iniQaVal.entries.inf[infind].drug2 + (iniQaVal.entries.inf[infind].drug2 == inf.drug2 ? ' - ✓' : ' - ✗' ) : 'Drug 2')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                v-model="inf.drug2"
                                @input="inf.drug = combiDrug(inf.drug1,inf.drug2); iniCalc();forceFormValidate('iniform');"
                                :rules="fieldRuleDep(inf.drug2,'drug2',inf.drug2)"
                                outlined
                                :items=iniRXSimple
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters style="height:60px;margin-top:0px;">
                        <v-col cols="3">
                            <v-menu
                                v-model="menu1[infind]"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                :disabled="readonly"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    class="demofields"
                                    v-model="inf.dos"
                                    :rules="fieldRuleDep(inf.dos,'inf_dos',inf.drug)"
                                    :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'Date: ' + iniQaVal.entries.inf[infind].dos + (iniQaVal.entries.inf[infind].dos == inf.dos ? ' - ✓' : ' - ✗' ) : 'Date Performed')"
                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                    dense
                                    outlined
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="inf.dos"
                                    @input="menu1[infind] = false;inf.startdt = dtConvert(inf.dos,inf.start,'start',false); inf.stopdt = dtConvert(inf.dos,inf.stop,'stop',false); inf.duration = countDuration(inf); inf.startdt = dtConvert(inf.dos,inf.start,'start',false); inf.stopdt = dtConvert(inf.dos,inf.stop,'stop',inf.next_day);"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="1">
                            <v-checkbox
                                style="margin:2px 5px;"
                                v-model="inf.alt_start"
                                @click="function(){if(inf.alt_start){cdiInline('add',inf.id,'Alternative Start Time')}else{cdiInline('del',inf.id,'Alternative Start Time')}}"
                                class="nextDay"
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'AS: ' + (iniQaVal.entries.inf[infind].alt_start == inf.alt_start ? ' ✓' : ' ✗' ) : 'ALT Start')"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                class="demofields"
                                v-model="inf.start"
                                :rules="fieldRuleDep(inf.start,'inf_start',inf.drug)"
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'Start: ' + iniQaVal.entries.inf[infind].start + (iniQaVal.entries.inf[infind].start == inf.start ? ' - ✓' : ' - ✗' ) : 'Start')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                dense
                                outlined
                                clearable
                                @blur="inf.startdt = dtConvert(inf.dos,inf.start,'start',false); inf.duration = countDuration(inf)"
                                @input="inf.startdt = dtConvert(inf.dos,inf.start,'start',false); inf.duration = countDuration(inf)"
                                type="time"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                class="demofields"
                                v-model="inf.stop"
                                :rules="fieldRuleDep(inf.stop,'inf_stop',inf.drug)"
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'Stop: ' + iniQaVal.entries.inf[infind].stop + (iniQaVal.entries.inf[infind].stop == inf.stop ? ' - ✓' : ' - ✗' ) : 'Stop')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                dense
                                outlined
                                clearable
                                @blur="inf.stopdt = dtConvert(inf.dos,inf.stop,'stop',inf.next_day); inf.duration = countDuration(inf)"
                                @input="inf.stopdt = dtConvert(inf.dos,inf.stop,'stop',inf.next_day); inf.duration = countDuration(inf)"
                                type="time"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-checkbox
                                style="margin:2px 5px;"
                                v-model="inf.next_day"
                                @click="inf.stopdt = dtConvert(inf.dos,inf.stop,'stop',inf.next_day); inf.duration = countDuration(inf)"
                                class="nextDay"
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'ND:' + (iniQaVal.entries.inf[infind].next_day == inf.next_day ? ' ✓' : ' ✗' ) : 'Next Day')"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                class="demofields"
                                v-model="inf.duration"
                                :label="(qaEnc && iniQaVal.entries.inf[infind] ? 'Duration: ' + iniQaVal.entries.inf[infind].duration + (iniQaVal.entries.inf[infind].duration == inf.duration ? ' - ✓' : ' - ✗' ) : 'Duration')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                style="font-weight:bold;"
                                dense
                                outlined
                                suffix="min(s)"
                                readonly
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col style="padding:0" cols="1">
                    <v-row no-gutters style="margin-bottom:5px;margin-top:20px;">
                        <v-spacer></v-spacer>
                        <v-col style="padding:0" cols="9">
                            <v-btn
                                depressed
                                x-small
                                color="error"
                                :outlined="proMode"
                                style="border-radius:0"
                                block
                                @click="deleteRow('inf',infind,null)"
                                :disabled="readonly"
                            >
                                -
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row no-gutters  style="margin-bottom:5px">
                        <v-spacer></v-spacer>
                        <v-col style="padding:0" cols="9">
                            <v-btn
                                depressed
                                x-small
                                block
                                color="success"
                                :outlined="proMode"
                                style="border-radius:0"
                                @click="copyRow('inf',infind,null)"
                                :disabled="readonly"
                            >
                                c
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-spacer></v-spacer>
                        <v-col style="padding:0" cols="9">
                            <v-btn
                                depressed
                                x-small
                                block
                                color="success"
                                :outlined="proMode"
                                style="border-radius:0"
                                @click="addRow('inf',infind,null)"
                                :disabled="readonly"
                            >
                                +
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <div v-for="(cdi,cdiind) in iniCDIs" :key="'cdi_' + cdiind">
                <v-row no-gutters v-if="cdi.infid == inf.id">
                    <v-col style="padding:0" cols="12">
                        <v-row no-gutters style="height:60px;margin-top:-10px;">
                            <v-col cols="1">
                                <v-text-field
                                    class="demofields"
                                    style="font-size:14px;font-weight:bold;"
                                    dense
                                    label="Type"
                                    outlined
                                    value="CDI"
                                    readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-select
                                class="demofields"
                                    dense
                                    label="Area"
                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                    v-model="cdi.area"
                                    disabled
                                    @input="forceFormValidate('iniform');"
                                    outlined
                                    :items=$store.getters.cdiReasons
                                ></v-select>
                            </v-col>
                            <v-col cols="1">
                                <v-text-field
                                    class="demofields"
                                    dense
                                    label="Qty"
                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                    type="number"
                                    min="1"
                                    v-model="cdi.qty"
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-combobox
                                    class="demofields"
                                    dense
                                    :rules="fieldRuleDep(cdi.clinical_resource,'cdi_clinical_resource',cdi.area)"
                                    label="Clinical Resource"
                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                    v-model="cdi.clinical_resource"
                                    @input="cdi.clinical_resource"
                                    outlined
                                    item-text="displayName"
                                    item-value="displayName"
                                    :items=$store.getters.Providers
                                ></v-combobox>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    class="demofields"
                                    dense
                                    label="Note"
                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                    v-model="cdi.note"
                                    outlined
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
            <v-divider v-if="infind+1 != iniVal.entries.inf.length" style="margin-top: -10px; margin-bottom:5px;"></v-divider>
        </div>

        <v-row no-gutters>
            <v-col cols="12" class="mt-2">
                <v-btn v-if="lastChanceUndo" class="my-2" small block color="warning" @click="undoResults">Undo Clear All ({{undoTimeLeft}}s left)</v-btn>
                <v-btn v-else class="my-2" :disabled="readonly" small block color="error" @click="clearResultsDialog">Clear All Entries</v-btn>
            </v-col>
        </v-row>

        <v-row v-if="!noCalc" no-gutters class="mb-0 mx-0" style="margin-top:20px;margin-left:-16px !important;margin-right:-16px !important;">
            <v-col cols="12">
                <v-tabs
                    :dark="proMode"
                    show-arrows
                    v-model="restab"
                    :background-color = "(proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                    grow
                    height="35"
                >
                    <v-tabs-slider :color="proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'"></v-tabs-slider>
                    <v-tab 
                        key="res"
                        :dark="proMode"
                        :style="'border-right:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                    >
                        I&I CALC RESULTS ({{iniVal.results.length}})
                    </v-tab>
                    <v-tab 
                        key="fixres"
                        v-if="iniVal.fixed_results && $store.getters.infDispFixed"
                        :dark="proMode"
                        :style="'border-right:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                    >
                        I&I POTENTIAL RESULTS ({{iniVal.fixed_results.length}}) - {{(difRes ? 'DIFF' : 'SAME')}}
                    </v-tab>
                </v-tabs>
                <v-tabs-items :style="'border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"  :dark="proMode" v-model="restab">
                    <v-tab-item 
                        key="res" 
                        :dark="proMode" 
                        style="margin-top:10px;margin-right:16px !important;margin-left:16px !important;padding-bottom:10px;"
                    >
                        <div v-if="iniVal.results.length>0">
                            <div v-for="(site, siteind) in sortedResults.sites" :key="'site_' + siteind">
                                <v-row no-gutters>
                                        <v-col style="padding:0" cols="4">
                                            <h3 style="margin-bottom:10px; font-size: 1.3em;">{{site}}</h3>
                                        </v-col>
                                        <v-col v-if="siteind==0">
                                            <v-switch
                                                style="padding:0;margin:0;"
                                                v-model="iniVal.overall.resOverride"
                                                label="Override Results"
                                            ></v-switch>
                                        </v-col>
                                        <v-col v-if="siteind==0" style="padding:0" cols="2">
                                            <v-btn class="float-right mt-n2" icon @click="iniCalc">
                                                <v-icon>mdi-cached</v-icon>
                                            </v-btn> 
                                        </v-col>
                                </v-row>
                                <div v-for="(res, resind) in sortedResults.results[site]" :key="'res_' + resind">
                                    <v-row no-gutters>
                                        <v-col style="padding:0" cols="11">
                                            <v-row v-if="res.nocharge" no-gutters style="height:40px;margin-top:5px;">
                                                <v-col cols="1">
                                                    <v-text-field
                                                        class="demofields"
                                                        style="font-size:14px;font-weight:bold;"
                                                        dense
                                                        label="Type"
                                                        outlined
                                                        value="NC"
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="7">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Reason"
                                                        outlined
                                                        v-model="res.code"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="1">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Qty"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        type="number"
                                                        min="1"
                                                        v-model="res.qty"
                                                        readonly
                                                        outlined
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Date Performed"
                                                        outlined
                                                        v-model="res.dos"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row v-else no-gutters style="height:40px;margin-top:5px;">
                                                <v-col cols="1">
                                                    <v-text-field
                                                        class="demofields"
                                                        style="font-size:14px;font-weight:bold;"
                                                        dense
                                                        label="Type"
                                                        outlined
                                                        value="CPT"
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Code"
                                                        outlined
                                                        v-model="res.code"
                                                        :readonly="!iniVal.overall.resOverride"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-combobox
                                                        v-model="res.mods"
                                                        @input="res.mods = allCapArray(res.mods)"
                                                        :items="$store.getters.iniMods"
                                                        :label="(qaEnc && iniQaVal.results[resind] ? 'Mods: ' + modStringer(iniQaVal.results[resind].mods) + (iniQaVal.results[resind].mods.toString() == res.mods.toString() ? ' - ✓' : ' - ✗' ) : 'Modifiers')"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        multiple
                                                        outlined
                                                        dense
                                                    >
                                                        <template v-slot:selection="{ attrs, item, parent, selected }">
                                                            <v-chip
                                                            v-if="item === item"
                                                            v-bind="attrs"
                                                            :input-value="selected"
                                                            label
                                                            small
                                                            outlined
                                                            >
                                                            <span class="pr-2">
                                                                {{ item }}
                                                            </span>
                                                            <v-icon
                                                                x-small
                                                                @click="parent.selectItem(item)"
                                                            >
                                                                mdi-close

                                                            </v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </v-combobox>
                                                </v-col>
                                                <v-col cols="1">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Qty"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        type="number"
                                                        min="1"
                                                        v-model="res.qty"
                                                        :readonly="!iniVal.overall.resOverride"
                                                        outlined
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Date Performed"
                                                        outlined
                                                        v-model="res.dos"
                                                        :readonly="!iniVal.overall.resOverride"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters style="height:50px;margin-top:0px;">
                                                <v-col cols="7">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        label="Drug"
                                                        outlined
                                                        v-model="res.drug"
                                                        :readonly="!iniVal.overall.resOverride"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-select
                                                        class="demofields"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        dense
                                                        label="Department"
                                                        v-model="res.department"
                                                        outlined
                                                        :readonly="!iniVal.overall.resOverride"
                                                        :items="departments"
                                                    ></v-select>
                                                    <!-- <v-text-field
                                                        class="demofields"
                                                        dense
                                                        label="Department"
                                                        outlined
                                                        v-model="res.department"
                                                        :readonly="!iniVal.overall.resOverride"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field> -->
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        label="Start Time"
                                                        style="font-size:14px;font-weight:bold;"
                                                        outlined
                                                        v-model="res.start"
                                                        :readonly="!iniVal.overall.resOverride"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    >
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col style="padding:0" cols="1">
                                            <v-row no-gutters style="margin-bottom:5px;margin-top:27px;">
                                                <v-spacer></v-spacer>
                                                <v-col style="padding:0" cols="9">
                                                    <v-btn
                                                        depressed
                                                        color="error"
                                                        :outlined="proMode"
                                                        style="border-radius:0"
                                                        block
                                                        :disabled="!iniVal.overall.resOverride"
                                                        @click="deleteRow('cpt',res.id)"
                                                    >
                                                        -
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-divider style="margin-bottom: 10px;" v-if="sortedResults.sites.length != siteind+1"></v-divider>
                            </div>
                            <div v-if="iniVal.overall.resOverride">
                                <v-row no-gutters>
                                    <v-spacer></v-spacer>
                                    <v-col style="padding:0" cols="12">
                                        <v-btn
                                            depressed
                                            block
                                            color="success"
                                            :outlined="proMode"
                                            style="border-radius:0"
                                            :disabled="readonly"
                                            @click="addRow('cpt',iniVal.results.length)"
                                        >
                                            Add Result
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                        <div class="pb-4" v-else>
                            <v-row no-gutters>
                                <v-col style="padding:0" cols="10">
                                    <h4>Results pending entries...</h4>
                                </v-col>
                                <v-col style="padding:0" cols="2">
                                    <v-btn class="float-right mt-n2" icon @click="iniCalc">
                                        <v-icon>mdi-cached</v-icon>
                                    </v-btn> 
                                </v-col>
                            </v-row>
                        </div>
                    </v-tab-item>
                    <v-tab-item 
                        key="fixres" 
                        v-if="iniVal.fixed_results && $store.getters.infDispFixed"
                        :dark="proMode" 
                        style="margin-top:10px;margin-right:16px !important;margin-left:16px !important;padding-bottom:10px;"
                    >
                        <div v-if="iniVal.fixed_results.length>0">
                            <div v-for="(site, siteind) in sortedFixedResults.sites" :key="'site_' + siteind">
                                <v-row no-gutters>
                                        <v-col style="padding:0" cols="10">
                                            <h3 style="margin-bottom:10px; font-size: 1.3em;">{{site}}</h3>
                                        </v-col>
                                        <v-col v-if="siteind==0" style="padding:0" cols="2">
                                            <v-btn class="float-right mt-n2" icon @click="iniCalc">
                                                <v-icon>mdi-cached</v-icon>
                                            </v-btn> 
                                        </v-col>
                                </v-row>
                                <div v-for="(res, resind) in sortedFixedResults.results[site]" :key="'res_' + resind">
                                    <v-row no-gutters>
                                        <v-col style="padding:0" cols="12">
                                            <v-row v-if="res.nocharge" no-gutters style="height:40px;margin-top:5px;">
                                                <v-col cols="1">
                                                    <v-text-field
                                                        class="demofields"
                                                        style="font-size:14px;font-weight:bold;"
                                                        dense
                                                        label="Type"
                                                        outlined
                                                        value="NC"
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="7">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Reason"
                                                        outlined
                                                        v-model="res.code"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="1">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Qty"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        type="number"
                                                        min="1"
                                                        v-model="res.qty"
                                                        readonly
                                                        outlined
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Date Performed"
                                                        outlined
                                                        v-model="res.dos"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row v-else no-gutters style="height:40px;margin-top:5px;">
                                                <v-col cols="1">
                                                    <v-text-field
                                                        class="demofields"
                                                        style="font-size:14px;font-weight:bold;"
                                                        dense
                                                        label="Type"
                                                        outlined
                                                        value="CPT"
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Code"
                                                        outlined
                                                        v-model="res.code"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-combobox
                                                        v-model="res.mods"
                                                        @input="res.mods = allCapArray(res.mods)"
                                                        :items="$store.getters.iniMods"
                                                        label="Modifiers"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        multiple
                                                        outlined
                                                        dense
                                                    >
                                                        <template v-slot:selection="{ attrs, item, parent, selected }">
                                                            <v-chip
                                                            v-if="item === item"
                                                            v-bind="attrs"
                                                            :input-value="selected"
                                                            label
                                                            small
                                                            outlined
                                                            >
                                                            <span class="pr-2">
                                                                {{ item }}
                                                            </span>
                                                            <v-icon
                                                                x-small
                                                                @click="parent.selectItem(item)"
                                                            >
                                                                mdi-close

                                                            </v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </v-combobox>
                                                </v-col>
                                                <v-col cols="1">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Qty"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        type="number"
                                                        min="1"
                                                        v-model="res.qty"
                                                        readonly
                                                        outlined
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Date Performed"
                                                        outlined
                                                        v-model="res.dos"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters style="height:50px;margin-top:0px;">
                                                <v-col cols="7">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        label="Drug"
                                                        outlined
                                                        v-model="res.drug"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        label="Department"
                                                        outlined
                                                        v-model="res.department"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        label="Start Time"
                                                        style="font-size:14px;font-weight:bold;"
                                                        outlined
                                                        v-model="res.start"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    >
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-divider style="margin-bottom: 10px;" v-if="sortedFixedResults.sites.length != siteind+1"></v-divider>
                            </div>
                        </div>
                        <div class="pb-4" v-else>
                            <h4>Results pending entries...</h4>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
    </v-form>
    <v-dialog
        v-model="clearResDiag"
        width="350"
    >
        <v-card>
            <v-card-title class="headline red darken-2 white--text pl-4 pb-2">
            Are you sure?
            </v-card-title>

            <v-card-text class="pt-5">
            This will remove all results that have been entered to this point. You have spent {{timeSinceOpen}} mins on this chart, please be sure before proceeding.
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                text
                @click="clearResults"
            >
                Confirm Clear Results
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
//import RXAPI from "../components/RXAPI.vue";
// <RXAPI
//     v-model="inf.drug"
//     :key="infchange"
//     :ro="readonly"
//     :filters="Injectable"
//     :qaVal="(qaEnc && iniQaVal.entries.inf[infind] ? iniQaVal.entries.inf[infind].drug : null)"
// />
import { ulid } from 'ulid';

export default{
  name: 'INICALC',
    props: {
        iniVal:{
            type:Object,
            required:true
        },
        iniQaVal:{
            type:Object,
            required:false
        },
        iniCDIs:{
            type:Array,
            required:false
        },
        timeOpened:{
            type:Number,
            required:true
        },
        iniValid:{
            type:Boolean,
            required:false
        },
        qaEnc:{
            type:Boolean,
            required:false
        },
        readonly:{
            type:Boolean,
            required:false
        },
    },
    components: { 
        // RXAPI 
    },
    data() {
        return {
            isLoading:false,
            iniValidInt:false,
            undoEnc:{},
            lastChanceUndo:false,
            countdownInt:null,
            undoTimeLeft:15,
            timeSinceOpen:0,
            clearResDiag: false,
            calculations:{
                hydration:{}, // dept_site_drug_dos/start_time, has stop?
                ivpush:{}, // dept_site_drug_dos, add time?
                ivinf:{}, // dept_site_drug_dos/start_time, has stop?
                chemo:{}
            },

            descriptionLimit: 50,
            entries: [],
            isLoading: false,
            model: null,
            searchAPI:null,

            infchange: 0,
            injchange: 0,

            found68: false,
            found68dos: [],

            menu1:[false],
            restab:"",
            difRes: false,

            fieldRule: function(v,f){
                let out = true;
                // if(this.reqCheck(f) && !v){
                //     out = 'Field Required to QA/Complete';
                // }else{
                // }
                return [out];
            },
            fieldRuleDep: function(v,f,df){
                let out = true;
                if(df && this.reqCheck(f) && !v){
                    //out = 'Field Required to QA/Complete';
                    out='';
                }else{
                }
                return [out];
            },
            fieldRuleInd: function(v,f,ind){
                // let fArr = f.split("_"),
                //     fComb = fArr[0] + "_" + ind + "_" + fArr[1];
                let out = true;
                // if(this.reqCheck(fComb) && !v.code){
                //     out = 'Field Required to QA/Complete';
                // }else{
                // }
                return [out];
            },
        };
    },
    computed:{
        ...mapGetters(["facSettings","noCalc","proMode","departments","ivSites","infType","injType","iniRXSimple","infIvpRule"]),
        items () {
            return this.entries.map(entry => {
            const Description = entry.code + " - " + (entry.name.length > this.descriptionLimit
                ? entry.name.slice(0, this.descriptionLimit) + '...'
                : entry.name)

            return Object.assign({}, entry, { Description })
            })
        },
        sortedResults(){
            let out = {
                    results:{},
                    sites:[]
                },
                res = this.iniVal.results;
            if(res.length>0){
                for(let r=0; r<res.length; r++){
                    if(out.results[res[r].site]){
                        out.results[res[r].site].push(res[r]);
                    }else{
                        out.results[res[r].site] = [res[r]];
                        out.sites.push(res[r].site);
                    }
                }
                out.sites = [...new Set(out.sites)];
                out.sites.sort();
            }
            return out;
        },
        sortedFixedResults(){
            let out = {
                    results:{},
                    sites:[]
                },
                res = this.iniVal.fixed_results;
            if(res.length>0){
                for(let r=0; r<res.length; r++){
                    if(out.results[res[r].site]){
                        out.results[res[r].site].push(res[r]);
                    }else{
                        out.results[res[r].site] = [res[r]];
                        out.sites.push(res[r].site);
                    }
                }
                out.sites = [...new Set(out.sites)];
                out.sites.sort();
            }
            return out;
        },
    },
    watch:{
      searchAPI (val) {
        // Items have already been loaded
        //if (this.items.length > 0) return
        if (val && val.length > 15) return
        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        // Lazily load input items
        fetch('https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms='+val)
          .then(res => res.json())
          .then(res => {
              let resarr = res[3],rlen=resarr.length,entries=[];
            for(let r=0; r<rlen; r++){
                entries.push({
                    name: resarr[r][1],
                    code: resarr[r][0],
                })
            }
            this.count = rlen
            this.entries = entries
          })
          .catch(err => {
             // console.log(err)
          })
          .finally(() => (this.isLoading = false))
      },
      iniValidInt(val){
          this.$emit('validChanged', val);
      }
    },
    mounted: function(){
        this.$store.dispatch("updateInIRXsimple");
        if(!this.iniVal){
            this.iniVal = {
                "overall":{
                    "mod25":false,
                    "mod59":false,
                    "modXU":false,
                    "noini":false,
                    "noprocs":false
                },
                "entries":{
                    "inf":[{
                        "id": ulid(),
                        "department":this.facSettings.ini_settings.def_department,
                        "site":"",
                        "type":"",
                        "drug":"",
                        "drug1":"",
                        "drug2":"",
                        "dos":"",
                        "start":"",
                        "stop":"",
                        "next_day":false,
                        "provider":"",
                        "duration":0
                    }],
                    "inj":[{
                        "id": ulid(),
                        "department":this.facSettings.ini_settings.def_department,
                        "site":"",
                        "type":"",
                        "drug":"",
                        "dos":"",
                        "qty":1
                    }],
                    "cpt":[{
                        "id": ulid(),
                        "department":this.facSettings.ini_settings.def_department,
                        "mods":[],
                        "code":{},
                        "dos":"",
                        "qty":1
                    }]
                },
                "results":[]
            };
        }
    },
    // beforeMount: function() {
    //     
    // },
    methods: {
        modStringer(mods){
            let out = "";
            for(let m=0; m<mods.length; m++){
                out += mods[m] + (mods.length != m+1 ? ", " : "");
            }
            return out;
        },
        sortResults(res){
            let out = {
                    results:{},
                    sites:[]
                };
            if(res.length>0){
                for(let r=0; r<res.length; r++){
                    if(out.results[res[r].site]){
                        out.results[res[r].site].push(res[r]);
                    }else{
                        out.results[res[r].site] = [res[r]];
                        out.sites.push(res[r].site);
                    }
                }
                out.sites = [...new Set(out.sites)];
                out.sites.sort();
            }
            return out;
        },
        clearResultsDialog(){
            this.clearResDiag = true;
            let d = new Date().getTime(),
                diff = Math.abs(d - this.timeOpened),
                out = Math.floor((diff/1000)/60);
            this.timeSinceOpen = out;
        },
        clearResults(){
            this.clearResDiag = false;
            this.undoEnc = JSON.parse(JSON.stringify(this.iniVal));
            this.iniVal.entries = {
                "inf":[{
                    "id": ulid(),
                    "department":this.facSettings.ini_settings.def_department,
                    "site":"",
                    "type":"",
                    "drug":"",
                    "drug1":"",
                    "drug2":"",
                    "dos":"",
                    "start":"",
                    "stop":"",
                    "next_day":false,
                    "provider":"",
                    "duration":0
                }],
                "inj":[{
                    "id": ulid(),
                    "department":this.facSettings.ini_settings.def_department,
                    "site":"",
                    "type":"",
                    "drug":"",
                    "dos":"",
                    "qty":1
                }],
                "cpt":[{
                    "id": ulid(),
                    "department":this.facSettings.ini_settings.def_department,
                    "mods":[],
                    "code":{},
                    "dos":"",
                    "qty":1
                }]
            };
            for(let c=this.iniCDIs.length-1; c>=0; c--){
                if(this.iniCDIs[c].infid){
                    this.iniCDIs.splice(c, 1);
                }
            }
            this.iniVal.results = [];
            this.lastChanceUndo = true;
            this.countdownTimer();
        },
        undoResults(){
            this.iniVal = this.undoEnc;
            this.lastChanceUndo = false;
            clearInterval(this.countdownInt);
        },
        countdownTimer(){
            // console.log("COUNTING DOWN " + this.undoTimeLeft);
            const self = this;
            this.countdownInt = setInterval(function() {
                // console.log("TL: " + self.undoTimeLeft);
                self.undoTimeLeft--;
                if (self.undoTimeLeft < 0) {
                    // console.log("TIMER DONE");
                    clearInterval(self.countdownInt);
                    self.lastChanceUndo = false;
                    self.undoEnc = {};
                    self.undoTimeLeft = 15;
                }
            }, 1000);
        },
        infValid(ind){
            let fComb = "INF_" + ind + "_drug";
            let out = false;
            if(this.reqCheck(fComb)){
                // console.log(ind + " inf REQUIRED!");
                // console.log("VALUE: " + JSON.stringify(this.iniVal.entries.inf[ind].drug));
                if(this.iniVal.entries.inf[ind].drug == "" || !this.iniVal.entries.inf[ind].drug){
                    out = false;
                }else{
                    out = true;
                }
            }else{
                out = true
            }
            return out;
        },
        injValid(ind){
            let fComb = "INJ_" + ind + "_drug";
            let out = false;
            if(this.reqCheck(fComb)){
                // console.log(ind + " inj REQUIRED!");
                // console.log("VALUE: " + JSON.stringify(this.iniVal.entries.inj[ind].drug));
                if(this.iniVal.entries.inj[ind].drug == "" || !this.iniVal.entries.inj[ind].drug){
                    out = false;
                }else{
                    out = true;
                }
            }else{
                out = true
            }
            return out;
        },
        validateform(){
            this.validate();
        },
        reqCheck(field){
            let out = false;
            if(this.$store.getters.requiredFields.indexOf(field)>=0){
                out = true;
            }
            // console.log("REQ CHECK: " + field + ": " + out);
            return out;
        },
        deleteRow(type,ind){
            let d = new Date().getTime();
            switch(type){
                case "cpt":
                    // console.log("DELETE: " + ind);
                    if(this.iniVal.results.length == 1){
                        this.iniVal.results[0] =  {"department":this.facSettings.ini_settings.def_department,"dos":(this.iniVal.entries.inf[0].dos ? this.iniVal.entries.inf[0].dos : ""),"site":"","start":"","starttime":"","drug":"","qty":1,"mods":[],"code":""};
                    }else{
                        for (let r=0; r<this.iniVal.results.length; r++){
                            if(this.iniVal.results[r].id == ind){
                                this.iniVal.results.splice(r,1);
                            }
                        }
                    } 
                    break;
                case "inf":
                    this.cdiInline('del',this.iniVal.entries.inf[ind].id,'all');
                    if(this.iniVal.entries.inf.length == 1){
                        this.iniVal.entries.inf[0] = {"id":ulid(),"department":this.facSettings.ini_settings.def_department,"dos":"","provider":"","site":"","start":"","stop":"","duration":0,"next_day":false,"drug":"","drug1":"","drug2":"","type":""};
                    }else{
                        this.iniVal.entries.inf.splice(ind, 1)
                    } 
                    this.iniCalc();
                    this.infchange++;
                    break;
                case "inj":
                    if(this.iniVal.entries.inj.length == 1){
                        this.iniVal.entries.inj[0] = {"id":ulid(),"department":this.facSettings.ini_settings.def_department,"dos":"","site":"","drug":"","type":"","qty":1};
                    }else{
                        this.iniVal.entries.inj.splice(ind, 1)
                    } 
                    this.injchange++;
                    break;
                case "cdi":
                    if(this.iniCDIs.length == 1){
                        this.iniCDIs[0] = {"area": "","qty": 1,"clinical_resource": "","note": ""};
                    }else{
                        this.iniCDIs.splice(ind, 1)
                    } 
                    break;
            }
        },
        copyRow(type,ind){
            let d = new Date().getTime();
            switch(type){
                case "cpt":
                    this.iniVal.entries.cpt.splice(ind + 1, 0, {"id":ulid(),"code": "","department": this.facSettings.ini_settings.def_department,"mods": [],"qty": 1,"dos":(this.iniVal.entries.cpt[0].dos ? this.iniVal.entries.cpt[0].dos : ""),"billing_provider": ""});
                    break;
                case "inf":
                    this.iniVal.entries.inf.splice(ind + 1, 0, {"id":ulid(),"department":(this.iniVal.entries.inf[ind].department ? this.iniVal.entries.inf[ind].department : this.facSettings.ini_settings.def_department),"dos":(this.iniVal.entries.inf[ind].dos ? this.iniVal.entries.inf[ind].dos : ""),"provider":(this.iniVal.entries.inf[ind].provider ? this.iniVal.entries.inf[ind].provider : ""),"site":(this.iniVal.entries.inf[ind].site ? this.iniVal.entries.inf[ind].site : ""),"start":"","stop":"","duration":0,"next_day":false,"drug":(this.iniVal.entries.inf[ind].drug ? this.iniVal.entries.inf[ind].drug : ""),"drug1":(this.iniVal.entries.inf[ind].drug1 ? this.iniVal.entries.inf[ind].drug1 : ""),"drug2":(this.iniVal.entries.inf[ind].drug2 ? this.iniVal.entries.inf[ind].drug2 : ""),"type":(this.iniVal.entries.inf[ind].type ? this.iniVal.entries.inf[ind].type : "")});
                    this.infchange++;
                    this.iniCalc();
                    break;
                case "inj":
                    this.iniVal.entries.inj.splice(ind + 1, 0, {"id":ulid(),"department":this.facSettings.ini_settings.def_department,"dos":(this.iniVal.entries.inj[0].dos ? this.iniVal.entries.inj[0].dos : ""),"site":"","drug":"","type":"","qty":1});
                    this.injchange++;
                    break;
                case "cdi":
                    this.iniCDIs.splice(ind + 1, 0, {"area": "","qty": 1,"clinical_resource": "","note": ""});
                    break;
            }              
        },
        addRow(type,ind){
            let d = new Date().getTime();
            switch(type){
                case "cpt":
                    let newVal = {"department":this.facSettings.ini_settings.def_department,"dos":(this.iniVal.entries.inf[0].dos ? this.iniVal.entries.inf[0].dos : ""),"site":"","start":"","starttime":"","drug":"","qty":1,"mods":[],"code":""};
                    if(this.iniVal.results.length>0){
                        newVal = JSON.parse(JSON.stringify(this.iniVal.results[this.iniVal.results.length-1]));
                    }
                    newVal.id = ulid();
                    newVal.manualAdd = true;
                    this.iniVal.results.push(newVal);
                    break;
                case "inf":
                    this.iniVal.entries.inf.splice(ind + 1, 0, {"id":ulid(),"department":this.facSettings.ini_settings.def_department,"dos":(this.iniVal.entries.inf[0].dos ? this.iniVal.entries.inf[0].dos : ""),"provider":"","site":"","start":"","stop":"","duration":0,"next_day":false,"drug":"","drug1":"","drug2":"","type":""});
                    this.infchange++;
                    break;
                case "inj":
                    this.iniVal.entries.inj.splice(ind + 1, 0, {"id":ulid(),"department":this.facSettings.ini_settings.def_department,"dos":(this.iniVal.entries.inj[0].dos ? this.iniVal.entries.inj[0].dos : ""),"site":"","drug":"","type":"","qty":1});
                    this.injchange++;
                    break;
                case "cdi":
                    this.iniCDIs.splice(ind + 1, 0, {"area": "","qty": 1,"clinical_resource": "","note": ""});
                    break;
            }              
        },
        cdiInline(verb,infid,area){
            // console.log("CDI INLINE: " + verb + " | " + area);
            if(verb == "add"){
                this.iniCDIs.push({"area": area,"qty": 1,"clinical_resource": "","note": "","infid":infid});
                this.forceFormValidate('iniform');
            }else if(verb == "del"){
                if(this.iniCDIs.length == 0){
                    this.iniCDIs[0] = {"area": "","qty": 1,"clinical_resource": "","note": ""};
                }else{
                    for(let c=this.iniCDIs.length-1; c>=0; c--){
                        if(this.iniCDIs[c].infid == infid){
                            if(this.iniCDIs[c].area == area || area == "all"){
                                this.iniCDIs.splice(c, 1);
                            }
                        }
                    }
                } 
            }
        },
        moveRow(type,ind,dir){
            // console.log(type + " | " + ind + " | " + dir);
            let c = this.iniVal.entries[type].splice(ind,1)[0];
            switch(dir){
                case "up":
                    this.iniVal.entries[type].splice(ind - 1, 0, c);
                    break;
                case "down":
                    this.iniVal.entries[type].splice(ind + 1, 0, c);
                    break;
            }
            if(type == "inf"){
                this.infchange++;
            }else{
                this.injchange++;
            }
            
        },
        formatTime(inp){
            // console.log(inp); // "([01]?[0-9]|2[0-3]):[0-5][0-9]"
            let out = "00:00";

            return inp;
        },
        dtConvert(dos,time,type,nd){
            // console.log(dos + " | " + time + " | " + type + " | " + nd);
            let out = null,preout;
            if(type == "stop" && time && nd){
                let d = new Date(dos + " " + "12:00"),
                        dp = new Date(d.getTime() + 86400000),
                        dateplus = dp.toISOString().split("T")[0];
                // console.log(d);
                // console.log(dp);
                // console.log(dateplus);
                preout = new Date(dateplus + " " + time);
                out = preout.getTime();
            }else if(time){
                preout = new Date(dos + " " + time);
                out = preout.getTime();
            }
            return out;
        },
        countDuration(inf){
            // console.log("COUNT DURATION");
            // console.log("ADD DAY? " + inf.next_day);
            let out = "NOSTOP";
            // if(inf.start && inf.stop){
            //     let startdt = new Date(inf.dos + " " + inf.start),
            //         stopdt = new Date(inf.dos + " " + inf.stop);
            //     if(inf.next_day){
            //         let d = new Date(inf.dos + " " + "12:00"),
            //             dp = new Date(d.getTime() + 86400000),
            //             dateplus = dp.toISOString().split("T")[0];
            //         // console.log(d);
            //         // console.log(dp);
            //         // console.log(dateplus);
            //         stopdt = new Date(dateplus + " " + inf.stop);
            //     }
            //     // console.log("STARTDT: " + startdt);
            //     // console.log("STOPDT: " + stopdt);
            //     if(startdt > stopdt){
            //         out = "PASTSTOP"
            //     }else{
            //         let diff = Math.abs(startdt - stopdt);
            //         out = Math.floor((diff/1000)/60);
            //     }
            // }
            // console.log(JSON.stringify(inf));
            if(inf.startdt && inf.stopdt){
                // console.log("STARTDT: " + inf.startdt);
                // console.log("STOPDT: " + inf.stopdt);
                if(inf.startdt > inf.stopdt){
                    out = "PASTSTOP"
                }else{
                    let diff = Math.abs(inf.startdt - inf.stopdt);
                    out = Math.floor((diff/1000)/60);
                }
            }
            inf.duration = out;
            //this.infCalc(inf);
            this.iniCalc();
            return out;
        },
        pushCPTRes(){

        },
        combiDrug(d1,d2){
            // console.log("DRUG IN: " + d1 + " | " + d2);
            let out="";
            if(d1 && d2){
                if(d1==d2){
                    out = d1;
                }else{
                    let arr = [d1,d2];
                    out = arr.sort().join("/");
                }
            }else if(d1){
                out = d1;
            }else{
                out = d2;
            }
            // console.log("DRUG OUT: " + out);
            return out;
        },
        overallMod(){
            let out = [],overall = this.iniVal.overall;;
            if(overall.mod25){ out.push("25") }
            if(overall.mod59){ out.push("59") }
            if(overall.modXU){ out.push("XU") }
            return out;
        },
        iniCalc(viewonly,fixres){
            // console.log("FIXED RES? " + fixres);
            // console.log("ENTRIES: " + JSON.stringify(this.iniVal.entries.inf));
            let noStopRun = false;
            this.found68 = false;
            this.found68dos=[];
            // CHECK AND MARK ANY DUPLICATE ENTRIES
            if(!fixres){
                for (let ae=this.iniVal.entries.inf.length-1; ae>=0; ae--){
                    let aeent = this.iniVal.entries.inf[ae], aekeys = Object.keys(aeent);
                    for (let ae1=this.iniVal.entries.inf.length-1; ae1>=0; ae1--){
                        let ae1ent = this.iniVal.entries.inf[ae1], ae1keys = Object.keys(ae1ent);
                        if(ae < ae1){
                            let matchies = [];
                            for (let ak=0; ak<aekeys.length; ak++){
                                if(aekeys[ak] != "id" && aekeys[ak] != "duplicate" && aekeys[ak] != "invalid_push"){
                                    matchies.push(aeent[aekeys[ak]] == ae1ent[aekeys[ak]]);
                                }
                            }
                            // console.log(ae + " vs. " + ae1 + " - " + JSON.stringify(matchies));
                            if(matchies.includes(false)){
                                // console.log("NO DUPE")
                                this.iniVal.entries.inf[ae1].duplicate = false;
                            }else{
                                // console.log("DUPE")
                                this.iniVal.entries.inf[ae1].duplicate = true;
                                this.iniVal.entries.inf[ae1].invalid_push = false;
                                this.iniVal.entries.inf[ae1].invalid_push_soft = false;
                                this.cdiInline("del",this.iniVal.entries.inf[ae1].id,"all");
                            }
                            if(aeent.type.toLowerCase().includes("push") && aeent.type == ae1ent.type && aeent.site == ae1ent.site && aeent.startdt == ae1ent.startdt){
                                let invPush = true, invPushSoft = false;
                                if(this.$store.getters.infSameSyrRule){
                                    invPush = false;
                                    // this.iniVal.entries.inf[ae1].invalid_push_soft = true;
                                    invPushSoft = true;
                                }
                                this.iniVal.entries.inf[ae1].invalid_push = invPush;
                                this.iniVal.entries.inf[ae1].invalid_push_soft = invPushSoft;
                                this.cdiInline("del",this.iniVal.entries.inf[ae1].id,"all");
                            }else if(ae1ent.invalid_push || ae1ent.invalid_push_soft){
                                this.iniVal.entries.inf[ae1].invalid_push = false;
                                this.iniVal.entries.inf[ae1].invalid_push_soft = false;
                            }
                        }
                    }
                }
            }

            let infsraw = JSON.parse(JSON.stringify(this.iniVal.entries.inf)),
                //infsraw = Array.from(this.iniVal.entries.inf),
                infs = infsraw.sort((prev, current) => (prev.startdt > current.startdt) ? 1 : -1), infslen = infs.length,
                injs = JSON.parse(JSON.stringify(this.iniVal.entries.inj)), injslen = injs.length,
                //injs = Array.from(this.iniVal.entries.inf.entries.inj), injslen = injs.length,
                overall = this.iniVal.entries.inf.overall;
            let calcs = {
                    hydrations:{},
                    ivpushs:{},
                    ivinfs:{},
                    chemos:{},
                    subs:{},
                    subscombined:{}
                },
                cpts = [];
            
            // SORT INFUSIONS INTO TYPES AND SITES BY DRUG/START TIME
            // console.log("INFS: " + JSON.stringify(infs));
            for (let f=0; f<infslen; f++){
                if(!infs[f].duplicate && !infs[f].invalid_push && infs[f].site != "IO"){
                    if(!fixres){
                        // CHECK FOR SITE NOT DOCUMENTED AND ADD CDI
                        let addCDIsnd=false, delCDIsnd=true;
                        if(infs[f].site == "SITE NOT DOCUMENTED"){
                            addCDIsnd=true;
                            delCDIsnd=false;
                        }
                        for(let c=this.iniCDIs.length-1; c>=0; c--){
                            if(this.iniCDIs[c].infid == infs[f].id){
                                if(this.iniCDIs[c].area == "Site Not Documented"){
                                    addCDIsnd = false;
                                }
                            }
                        }
                        if(addCDIsnd){
                            this.cdiInline("add",infs[f].id,"Site Not Documented");
                        }
                        if(delCDIsnd){
                            this.cdiInline("del",infs[f].id,"Site Not Documented");
                        }
                    }

                    // let ready = (infs[f].department && infs[f].site && infs[f].type && infs[f].startdt && infs[f].stopdt);
                    let ready = (infs[f].department && infs[f].site && infs[f].type && infs[f].drug && infs[f].startdt);
                    if(ready){                    
                        // DETERMINE HIERARCHY BY TYPE
                        let stype = (infs[f].type.toLowerCase().includes("hydration") ? "hydrations" : 
                                        (infs[f].type.toLowerCase().includes("chemo") ? "chemos" : 
                                            (infs[f].type.toLowerCase().includes("push") ? "ivpushs" : 
                                                (infs[f].type.toLowerCase().includes("infusion") ? "ivinfs" :
                                                    null))));
                        // console.log("CALCS BEF: " + JSON.stringify(calcs));
                        // console.log("TYPE: " + infs[f].type);
                        // console.log("STYPE: " + stype);
                        // console.log("SITE: " + infs[f].site);
                        // console.log("DURATION: " + infs[f].duration);
                        let origStype = stype;

                        // CHECK FOR NO STOP AND >15 PUSH FOR CDI AND/OR CALC RES AND/OR CHANGE STYPE
                        let addCDInst=false, delCDInst=true,
                            addCDIipo=false, delCDIipo=true,
                            addCDIiiu=false, delCDIiiu=true;
                        if(infs[f].duration == "NOSTOP" && stype != "ivpushs"){
                            // console.log("NO STOP DETECTED, FIX RES: " + fixres);
                            if(fixres){
                                // console.log("FIXING NO STOP");
                                infs[f].duration = 60;
                                infs[f].stopdt = (infs[f].startdt + 3600000);
                                delCDInst=false;
                            }else{
                                noStopRun = true;
                                addCDInst=true;
                                delCDInst=false;
                            }
                        }else if(infs[f].duration > 15 && stype == "ivpushs"){
                            addCDIipo=true;
                            delCDIipo=false;
                            stype = "ivinfs";
                        }else if(infs[f].duration < 15 && stype == "ivinfs"){
                            addCDIiiu=true;
                            delCDIiiu=false;
                            if(this.facSettings.ini_settings.repeat_med_rule){
                                stype = "ivpushs";
                            }
                        }

                        // APPLY INF IVP RULE
                        if(addCDInst){
                            // console.log("INF IVP RULE: " + this.infIvpRule);
                            if(stype == "ivinfs"){
                                if(this.infIvpRule == "NO COUNT"){

                                }else if(this.infIvpRule == "NEW DRUG"){
                                    infs[f].drug = infs[f].drug + " (NOSTOP)"
                                }else{
                                    infs[f].type = "Medication IV Push";
                                    stype = "ivpushs";
                                }                                
                            }
                        }

                        // CHECK IVPUSHS AND/OR INFUSIONS ARE NOT FAR ENOUGH APART                        
                        for(let ff=f+1; ff<infslen; ff++){
                            if(infs[f].type != "hydrations" && !infs[f].nocalc && !infs[ff].duplicate && !infs[ff].invalid_push){
                                let ready2 = (infs[ff].department && infs[ff].site && infs[ff].type && infs[ff].drug && infs[ff].startdt),
                                    stype2 = (infs[ff].type.toLowerCase().includes("hydration") ? "hydrations" : 
                                                (infs[ff].type.toLowerCase().includes("chemo") ? "chemos" :  
                                                    (infs[ff].type.toLowerCase().includes("push") ? "ivpushs" : 
                                                        (infs[ff].type.toLowerCase().includes("infusion") ? "ivinfs" :
                                                            null)))),
                                    stopTime = (infs[f].stopdt ? infs[f].stopdt : (stype == "ivpushs" ? infs[f].startdt : null));
                                let origStype2 = stype2;
                                
                                let addCDInst2=false;
                                // APPLY INF IVP RULE AHEAD
                                if(infs[ff].duration == "NOSTOP" && stype2 != "ivpushs"){
                                    if(fixres){
                                        // console.log("FIXING DURATION 2");
                                        infs[ff].duration = 60;
                                        infs[ff].stopdt = (infs[ff].startdt + 3600000);
                                    }else{
                                        noStopRun = true;
                                        addCDInst2=true;
                                    }
                                }else if(infs[ff].duration < 15 && stype2 == "ivinfs"){
                                    if(this.facSettings.ini_settings.repeat_med_rule){
                                        stype2 = "ivpushs";
                                    }
                                }
                                if(addCDInst2){
                                    if(stype2 == "ivinfs"){
                                        if(this.infIvpRule == "NO COUNT"){

                                        }else if(this.infIvpRule == "NEW DRUG"){
                                            infs[ff].drug = infs[ff].drug + " (NOSTOP)"
                                        }else{
                                            //infs[ff].type = "Medication IV Push";
                                            stype2 = "ivpushs";
                                        }                                
                                    }
                                }

                                if(ready2 && stopTime && stype2 != "hydrations" && stype != stype2){
                                    if(infs[f].site == infs[ff].site && infs[f].drug == infs[ff].drug){
                                        // console.log("START-STOP: " + infs[ff].startdt + " - " + stopTime);
                                        let diff = Math.abs(infs[ff].startdt - stopTime),
                                            tbtwn = Math.floor((diff/1000)/60);
                                        // console.log("HYD DIF: " + diff);
                                        // console.log("HYD TBTWN: " + tbtwn);
                                        if(tbtwn < 31 || stopTime>infs[ff].startdt){
                                            // console.log("NO CHARGE");
                                            let durA = Number.isInteger(infs[f].duration) ? infs[f].duration : 0,
                                                durB = Number.isInteger(infs[ff].duration) ? infs[ff].duration : 0;
                                            if(durA>durB){
                                                infs[ff].nocalc = true;
                                            }else{
                                                infs[f].nocalc = true;
                                            }
                                            cpts.push({
                                                id: ulid(),
                                                code: "SAME DRUG NOT 30 APART",
                                                nocharge:true,
                                                qty: 1,
                                                department: infs[ff].department,
                                                site: infs[ff].site,
                                                drug: infs[ff].drug,
                                                dos: infs[ff].dos,
                                                starttime: infs[ff].startdt,
                                                start:infs[ff].start,
                                                mods:[]
                                            });
                                        }else{
                                            infs[ff].nocalc = false;
                                            infs[ff].samedrug = true;
                                            infs[f].samedrug = true;
                                        }
                                    }
                                }
                            }
                        }

                        for(let c=this.iniCDIs.length-1; c>=0; c--){
                            if(this.iniCDIs[c].infid == infs[f].id){
                                if(this.iniCDIs[c].area == "No Stop Time Recorded"){
                                    addCDInst = false;
                                }
                                if(this.iniCDIs[c].area == "IV Push Over 15 Minutes"){
                                    addCDIipo = false;
                                }
                                if(this.iniCDIs[c].area == "Infusion Under 15 Minutes"){
                                    addCDIiiu = false;
                                }
                            }
                        }
                        if(addCDInst){
                            this.cdiInline("add",infs[f].id,"No Stop Time Recorded");
                            // console.log("ADD NO STOP: " + infs[f].drug);
                            if(stype == "hydrations"){
                                cpts.push({
                                    id: ulid(),
                                    code: "NO STOP TIME",
                                    nocharge:true,
                                    qty: 1,
                                    department: infs[f].department,
                                    site: infs[f].site,
                                    drug: infs[f].drug,
                                    dos: infs[f].dos,
                                    starttime: infs[f].startdt,
                                    start:infs[f].start,
                                    mods:[]
                                });
                            }
                        }
                        if(!fixres){
                            if(delCDInst){
                                // console.log("DELETE NO STOP: " + infs[f].drug);
                                this.cdiInline("del",infs[f].id,"No Stop Time Recorded");
                            }
                            if(addCDIipo){
                                this.cdiInline("add",infs[f].id,"IV Push Over 15 Minutes");
                            }
                            if(delCDIipo){
                                this.cdiInline("del",infs[f].id,"IV Push Over 15 Minutes");
                            }
                            if(addCDIiiu){
                                this.cdiInline("add",infs[f].id,"Infusion Under 15 Minutes");
                            }
                            if(delCDIiiu){
                                this.cdiInline("del",infs[f].id,"Infusion Under 15 Minutes");
                            }
                            if(!viewonly){
                                this.forceFormValidate('iniform');
                            }
                        }

                        if(!infs[f].nocalc){
                            // console.log("CALC IT: " + JSON.stringify(infs[f]))
                            // WORK THROUGH HIERARCHY BOTTOM UP
                            if(stype == "hydrations" && infs[f].stopdt){
                                let unid = infs[f].drug.toLowerCase() + "_" + infs[f].startdt;
                                // console.log("ID: " + unid);
                                if(calcs[stype][infs[f].site] && calcs[stype][infs[f].site][unid] && calcs[stype][infs[f].site][unid].duration){
                                    if(infs[f].duration > calcs[stype][infs[f].site][unid].duration){
                                        calcs[stype][infs[f].site][unid].duration = infs[f].duration;
                                        calcs[stype][infs[f].site][unid].department = infs[f].department;
                                        calcs[stype][infs[f].site][unid].site = infs[f].site;
                                        calcs[stype][infs[f].site][unid].dos = infs[f].dos;
                                        calcs[stype][infs[f].site][unid].startdt = infs[f].startdt;
                                        calcs[stype][infs[f].site][unid].start = infs[f].start;
                                        calcs[stype][infs[f].site][unid].stopdt = infs[f].stopdt;
                                        calcs[stype][infs[f].site][unid].drug = infs[f].drug;
                                    }
                                }else if(calcs[stype][infs[f].site] && calcs[stype][infs[f].site][unid]){
                                    if(!isNaN(infs[f].duration)){
                                        calcs[stype][infs[f].site][unid].duration = infs[f].duration;
                                        calcs[stype][infs[f].site][unid].department = infs[f].department;
                                        calcs[stype][infs[f].site][unid].site = infs[f].site;
                                        calcs[stype][infs[f].site][unid].dos = infs[f].dos;
                                        calcs[stype][infs[f].site][unid].startdt = infs[f].startdt;
                                        calcs[stype][infs[f].site][unid].start = infs[f].start;
                                        calcs[stype][infs[f].site][unid].stopdt = infs[f].stopdt;
                                        calcs[stype][infs[f].site][unid].drug = infs[f].drug;
                                    }
                                }else if(calcs[stype][infs[f].site]){
                                    calcs[stype][infs[f].site][unid] = {
                                        duration: infs[f].duration,
                                        department: infs[f].department,
                                        site: infs[f].site,
                                        dos: infs[f].dos,
                                        startdt: infs[f].startdt,
                                        start: infs[f].start,
                                        stopdt: infs[f].stopdt,
                                        drug: infs[f].drug
                                    }
                                }else{
                                    calcs[stype][infs[f].site] = {};
                                    calcs[stype][infs[f].site][unid] = {
                                        duration: infs[f].duration,
                                        department: infs[f].department,
                                        site: infs[f].site,
                                        dos: infs[f].dos,
                                        startdt: infs[f].startdt,
                                        start: infs[f].start,
                                        stopdt: infs[f].stopdt,
                                        drug: infs[f].drug
                                    }
                                }
                            }else if(stype == "ivpushs" || stype == "ivinfs" || stype == "chemos"){
                                if(!calcs.subs[infs[f].site]){
                                    calcs.subs[infs[f].site] = [];
                                }
                                calcs.subs[infs[f].site].push({
                                    startdt:infs[f].startdt,
                                    stopdt:(stype == "ivpushs" ? infs[f].startdt+900000 : infs[f].stopdt),
                                    duration:(stype == "ivpushs" ? 15 : infs[f].duration),
                                    type:stype,
                                    drug:infs[f].drug,
                                    department:infs[f].department
                                });

                                if(calcs[stype][infs[f].site] && calcs[stype][infs[f].site][infs[f].drug.toLowerCase()]){
                                    calcs[stype][infs[f].site][infs[f].drug.toLowerCase()].infs.push({
                                        duration: infs[f].duration,
                                        department: infs[f].department,
                                        site: infs[f].site,
                                        dos: infs[f].dos,
                                        startdt: infs[f].startdt,
                                        start: infs[f].start,
                                        stopdt: infs[f].stopdt,
                                        samedrug: infs[f].samedrug,
                                        drug: infs[f].drug
                                    });
                                    if(isNaN(infs[f].duration) || isNaN(calcs[stype][infs[f].site][infs[f].drug.toLowerCase()].tduration)){
                                        calcs[stype][infs[f].site][infs[f].drug.toLowerCase()].tduration = infs[f].duration;
                                    }else{
                                        calcs[stype][infs[f].site][infs[f].drug.toLowerCase()].tduration += infs[f].duration;
                                    }
                                    calcs[stype][infs[f].site][infs[f].drug.toLowerCase()].multidrug = (infs[f].drug1 && infs[f].drug2 ? true : false);
                                }else if(calcs[stype][infs[f].site]){
                                    calcs[stype][infs[f].site][infs[f].drug.toLowerCase()] = {
                                        infs: [{
                                            duration: infs[f].duration,
                                            department: infs[f].department,
                                            site: infs[f].site,
                                            dos: infs[f].dos,
                                            startdt: infs[f].startdt,
                                            start: infs[f].start,
                                            stopdt: infs[f].stopdt,
                                            samedrug: infs[f].samedrug,
                                            drug: infs[f].drug
                                        }],
                                        tduration: infs[f].duration,
                                        multidrug: (infs[f].drug1 && infs[f].drug2 ? true : false)
                                    };
                                }else{
                                    calcs[stype][infs[f].site] = {};
                                    calcs[stype][infs[f].site][infs[f].drug.toLowerCase()] = {
                                        infs: [{
                                            duration: infs[f].duration,
                                            department: infs[f].department,
                                            site: infs[f].site,
                                            dos: infs[f].dos,
                                            startdt: infs[f].startdt,
                                            start: infs[f].start,
                                            stopdt: infs[f].stopdt,
                                            samedrug: infs[f].samedrug,
                                            drug: infs[f].drug
                                        }],
                                        tduration: infs[f].duration,
                                        multidrug: (infs[f].drug1 && infs[f].drug2 ? true : false)
                                    };
                                }
                            }
                        }else{
                            // console.log("NO CALC: " + JSON.stringify(infs[f]));
                        } 
                        // console.log("CALCS AFT: " + JSON.stringify(calcs));
                    }
                }else if(infs[f].site == "IO"){
                    cpts.push({
                        id: ulid(),
                        code: "36680",
                        qty: 1,
                        department: infs[f].department,
                        site: infs[f].site,
                        drug: infs[f].drug,
                        dos: infs[f].dos,
                        starttime: infs[f].startdt,
                        start: infs[f].start,
                        mods:this.overallMod()
                    });
                }
            };

            let hydsites = Object.keys(calcs.hydrations), hslen = hydsites.length,
                ivpsites = Object.keys(calcs.ivpushs), ivplen = ivpsites.length,
                ivisites = Object.keys(calcs.ivinfs), ivilen = ivisites.length,
                chisites = Object.keys(calcs.chemos), chilen = chisites.length,
                subsites = Object.keys(calcs.subs), sublen = subsites.length;

            // CHECK IVPUSHS AND INFUSIONS AND MARK SAME DRUG 
            // for(let iv2=0; iv2<ivilen; iv2++){
            //     if(calcs.ivpushs[ivisites[iv2]]){
            //         let ividrugs2 = Object.keys(calcs.ivinfs[ivisites[iv2]]), ividrugs2len = ividrugs2.length,
            //             ivpdrugs2 = Object.keys(calcs.ivpushs[ivisites[iv2]]);
            //         if(ividrugs2.some(item => ivpdrugs2.includes(item))){
            //             for(let id=0; id<ividrugs2len; id++){
            //                 if(calcs.ivpushs[ivisites[iv2]][ividrugs2[id]]){
            //                     let iviinfs2 = Array.from(calcs.ivinfs[ivisites[iv2]][ividrugs2[id]].infs),
            //                         ivpinfs2 = Array.from(calcs.ivpushs[ivisites[iv2]][ividrugs2[id]].infs),
            //                         infcombraw = [...iviinfs2,...ivpinfs2],
            //                         infcomb = infcombraw.sort((prev, current) => (prev.startdt > current.startdt) ? 1 : -1), infcomblen = infcomb.length;
            //                     for (let i=0; i<infcomblen-1; i++){
            //                         if(){

            //                         }
            //                     }
            //                 }
            //             }
            //         }
            //     }
            // };
            // -------- OR THIS COULD BE USED FOR REFACTORING THE BELOW --------
            
            // COMBINE OVERLAPPING SUBTRACTIONS
            
            for(let ss=0; ss<sublen; ss++){
                let current = JSON.parse(JSON.stringify(calcs.subs[subsites[ss]])).sort((prev, current) => (prev.startdt > current.startdt) ? 1 : -1);
                let subsout = {};
                for(let s=0; s<current.length; s++){
                    if(!current[s].skip){
                        let curstart = current[s].startdt,
                        curstop = current[s].stopdt;
                        subsout[curstart] = current[s];
                        subsout[curstart].drugs = [];
                        for(let s2=s+1; s2<current.length; s2++){
                            let compstart = current[s2].startdt,
                                compstop = current[s2].stopdt;
                            if(compstart<curstop && compstop>curstop){
                                let diff = Math.abs(compstop - curstart),
                                    dur = Math.floor((diff/1000)/60);
                                subsout[curstart].stopdt = compstop;
                                subsout[curstart].duration = dur;
                                subsout[curstart].drugs.push(current[s2].drug);
                                
                                curstop = compstop;
                                current[s2].skip = true;
                            }else{
                                // console.log("NO OVERLAP");
                            }
                        }
                    }else{
                        // console.log("ALREADY COMBINED");
                    }
                }
                calcs.subscombined[subsites[ss]] = subsout;
            }
            // console.log("CALCS AFT2: " + JSON.stringify(calcs));

            let subscombsites = Object.keys(calcs.subscombined), subcomblen = subscombsites.length;

            // CHECK FOR SUBTRACTABLE TIME
            for(let sc=0; sc<subcomblen; sc++){
                let subcombstart = Object.keys(calcs.subscombined[subscombsites[sc]]), subcombstartlen = subcombstart.length;
                for(let d=0; d<subcombstartlen; d++){
                    let subsc = JSON.parse(JSON.stringify(calcs.subscombined[subscombsites[sc]][subcombstart[d]]));
                    for(let hs=0; hs<hslen; hs++){
                        let unis = Object.keys(calcs.hydrations[hydsites[hs]]), unislen = unis.length,harr=[];
                        for(let us=0; us<unislen; us++){
                            // let infStopDT = (subsc.stopdt ? subsc.stopdt : subsc.startdt-900000);
                            // IF INFSUION SAME TIME OR BEFORE AND AFTER HYDRATION -> THEN SKIP
                            if( subscombsites[sc]==hydsites[hs]
                                && calcs.hydrations[hydsites[hs]][unis[us]].startdt >= subsc.startdt 
                                && calcs.hydrations[hydsites[hs]][unis[us]].stopdt <= subsc.stopdt
                                ){
                                // console.log("SKIPPING HYD");
                                calcs.hydrations[hydsites[hs]][unis[us]].skip = true;
                            }
                            // IF HYDRATION BEFORE AND AFTER INFUSION -> THEN SUBTRACT TOTAL INFUSION
                            else if( subscombsites[sc]==hydsites[hs]
                                && calcs.hydrations[hydsites[hs]][unis[us]].startdt <= subsc.startdt 
                                && calcs.hydrations[hydsites[hs]][unis[us]].stopdt >= subsc.stopdt
                                ){
                                // console.log("NORMAL SUBTRACTING TIME");
                                // console.log("B: " + calcs.hydrations[hydsites[hs]][unis[us]].duration);
                                if(calcs.hydrations[hydsites[hs]][unis[us]].duration > 15 && (calcs.hydrations[hydsites[hs]][unis[us]].duration - subsc.duration) > 0){
                                    if(subsc.duration > 15){
                                        calcs.hydrations[hydsites[hs]][unis[us]].duration = calcs.hydrations[hydsites[hs]][unis[us]].duration - subsc.duration;
                                    }else{
                                        calcs.hydrations[hydsites[hs]][unis[us]].duration = calcs.hydrations[hydsites[hs]][unis[us]].duration - 15;
                                    }
                                }else if(subsc.duration == "NOSTOP"){
                                    calcs.hydrations[hydsites[hs]][unis[us]].duration = calcs.hydrations[hydsites[hs]][unis[us]].duration - 15;
                                }else{
                                    calcs.hydrations[hydsites[hs]][unis[us]].duration = 0;
                                }
                                // console.log("A: " + calcs.hydrations[hydsites[hs]][unis[us]].duration);
                            }
                            // IF HYDRATION START OVERLAPS INFUSION -> THEN SUBTRACT OVERLAP
                            else if( subscombsites[sc]==hydsites[hs]
                                && calcs.hydrations[hydsites[hs]][unis[us]].startdt >= subsc.startdt 
                                && calcs.hydrations[hydsites[hs]][unis[us]].startdt <= subsc.stopdt
                                && calcs.hydrations[hydsites[hs]][unis[us]].stopdt >= subsc.stopdt 
                                ){
                                // console.log("SUBTRACTING TIME START OVERLAP");
                                // console.log("B: " + calcs.hydrations[hydsites[hs]][unis[us]].duration);
                                let subDur = (((subsc.stopdt - calcs.hydrations[hydsites[hs]][unis[us]].startdt)/1000)/60);
                                if((calcs.hydrations[hydsites[hs]][unis[us]].duration - subDur) > 0){
                                    calcs.hydrations[hydsites[hs]][unis[us]].duration = calcs.hydrations[hydsites[hs]][unis[us]].duration - subDur;
                                }else{
                                    calcs.hydrations[hydsites[hs]][unis[us]].duration = 0;
                                }
                                // console.log("A: " + calcs.hydrations[hydsites[hs]][unis[us]].duration);
                            }
                            // IF HYDRATION STOP OVERLAPS INFUSION -> THEN SUBTRACT OVERLAP
                            else if( 
                                subscombsites[sc]==hydsites[hs] 
                                && calcs.hydrations[hydsites[hs]][unis[us]].startdt <= subsc.startdt 
                                && calcs.hydrations[hydsites[hs]][unis[us]].stopdt >= subsc.startdt 
                                && calcs.hydrations[hydsites[hs]][unis[us]].stopdt <= subsc.stopdt 
                                ){
                                // console.log("SUBTRACTING TIME STOP OVERLAP");
                                // console.log("B: " + calcs.hydrations[hydsites[hs]][unis[us]].duration);
                                let subDur = (((calcs.hydrations[hydsites[hs]][unis[us]].stopdt - subsc.startdt)/1000)/60);
                                if((calcs.hydrations[hydsites[hs]][unis[us]].duration - subDur) > 0){
                                    calcs.hydrations[hydsites[hs]][unis[us]].duration = calcs.hydrations[hydsites[hs]][unis[us]].duration - subDur;
                                }else{
                                    calcs.hydrations[hydsites[hs]][unis[us]].duration = 0;
                                }
                                // console.log("A: " + calcs.hydrations[hydsites[hs]][unis[us]].duration);
                            }
                        }
                    }
                }
            }

            // CODE BY HIERARCHY 1. HYDRATION, 2. IV PUSH, 3. IV INFUSIONS, 4. CHEMO
            // 1. HYDRATION - calcs[stype][infs[f].site][unid]
            for(let hs=0; hs<hslen; hs++){
                let unis = Object.keys(calcs.hydrations[hydsites[hs]]), unislen = unis.length,harr=[],hydtotdur=0;
                for(let us=0; us<unislen; us++){
                    if(calcs.hydrations[hydsites[hs]][unis[us]].skip){
                        // console.log("GOT TRUMPED");
                    }else if(calcs.hydrations[hydsites[hs]][unis[us]].duration > 30){
                        harr.push(calcs.hydrations[hydsites[hs]][unis[us]]);
                        hydtotdur += calcs.hydrations[hydsites[hs]][unis[us]].duration;
                    }
                }
                // console.log("HARR: " + JSON.stringify(harr));
                harr.sort((a, b) => {
                    return a.startdt - b.startdt;
                });
                // console.log("HARR SORT: " + JSON.stringify(harr));
                if(harr.length>0){
                    if(!this.facSettings.ini_settings.ro_department){
                        // console.log("DEPT HYDS");
                        //let maxhyd = harr.reduce((prev, current) => (prev.duration > current.duration) ? prev : current);
                        // console.log("TOT HYD DUR: " + hydtotdur);
                        let initCPT = false, initsub=1;
                        if(hydtotdur>30){
                            let lohours=0;
                            for (let ha=0; ha<harr.length; ha++){
                                // console.log("IN LOHOURS " + lohours);
                                // console.log("IT DUR " + harr[ha].duration);
                                hydtotdur-=harr[ha].duration;
                                // console.log("IT TOT HYD DUR: " + hydtotdur);

                                let ithours =  (harr[ha].duration/60);
                                ithours-=lohours;
                                // if(initsub){
                                //     ithours-=lohours;
                                // }else{
                                //     ithours+=lohours;
                                // }
                                // console.log("ITHOURS " + ithours);
                                if(!initCPT){
                                    if(ithours>.5){
                                        cpts.push({
                                            id: ulid(),
                                            code: "96360",
                                            qty: 1,
                                            department: harr[ha].department,
                                            site: hydsites[hs],
                                            drug: harr[ha].drug,
                                            dos: harr[ha].dos,
                                            starttime: harr[ha].startdt,
                                            start:harr[ha].start,
                                            mods:this.overallMod()
                                        });
                                        // console.log("INIT QTY 1")
                                        initCPT = true;
                                        ithours-=.5;
                                    }
                                }
                                let itharr = ithours.toFixed(4).toString().split(".");
                                if(initsub>0){
                                    ithours-=initsub
                                    if(ithours<0){
                                        initsub = ithours*-1;
                                        ithours = 0;
                                    }else{
                                        initsub = 0;
                                    }
                                    // if(ithours>1){
                                    //     ithours-=1;
                                    //     initsub = true;
                                    // }else{
                                    //     lohours = Number("." + itharr[1]);
                                    // }
                                }
                                if(initsub==0){
                                    let itqty;
                                    if(ha==harr.length-1){
                                        itqty = Math.ceil(ithours);
                                        //itqty = Number(itharr[0]);
                                    }else{
                                        itqty = Math.ceil(ithours);
                                        //itqty = Number(itharr[0]);
                                        lohours = 1-Number("." + itharr[1]);
                                    }
                                    // console.log("ITQTY " + itqty);
                                    if(itqty>0){
                                        cpts.push({
                                            id: ulid(),
                                            code: "96361",
                                            qty: itqty,
                                            department: harr[ha].department,
                                            site: hydsites[hs],
                                            drug: harr[ha].drug,
                                            dos: harr[ha].dos,
                                            starttime: harr[ha].startdt,
                                            start:harr[ha].start,
                                            mods:this.overallMod()
                                        });
                                    }else{
                                        // let itharr = ithours.toString().split(".");
                                        // lohours = Number("." + itharr[1]);
                                    }
                                    // console.log("OUT LOHOURS " + lohours);
                                }
                            }
                        }else{
                            cpts.push({
                                id: ulid(),
                                code: "LESS THAN 30 MINS",
                                nocharge:true,
                                qty: 1,
                                department: harr[ha].department,
                                site: hydsites[hs],
                                drug: harr[ha].drug,
                                dos: harr[ha].dos,
                                starttime: harr[ha].startdt,
                                start:harr[ha].start,
                                mods:[]
                            });
                        }
                    }else{
                        // console.log("NORMAL HYDS");
                        let maxhyd = harr.reduce((prev, current) => (prev.duration > current.duration) ? prev : current);
                        // console.log("HYD DUR: " + hydtotdur);
                        if(hydtotdur>30){
                            cpts.push({
                                id: ulid(),
                                code: "96360",
                                qty: 1,
                                department: harr[0].department,
                                site: hydsites[hs],
                                drug: maxhyd.drug,
                                dos: maxhyd.dos,
                                starttime: maxhyd.startdt,
                                start:maxhyd.start,
                                mods:this.overallMod()
                            });
                            if(hydtotdur>90){
                                cpts.push({
                                    id: ulid(),
                                    code: "96361",
                                    qty: Math.ceil((hydtotdur-90)/60),
                                    department: (harr[1].department ? harr[1].department : harr[0].department),
                                    site: hydsites[hs],
                                    drug: maxhyd.drug,
                                    dos: maxhyd.dos,
                                    starttime: maxhyd.startdt,
                                    start:maxhyd.start,
                                    mods:this.overallMod()
                                });
                            }
                        }else{
                            cpts.push({
                                id: ulid(),
                                code: "LESS THAN 30 MINS",
                                nocharge:true,
                                qty: 1,
                                department: maxhyd.department,
                                site: hydsites[hs],
                                drug: maxhyd.drug,
                                dos: maxhyd.dos,
                                starttime: maxhyd.startdt,
                                start:maxhyd.start,
                                mods:[]
                            });
                        }
                    }
                }
            }
            // console.log("HYD CPTS: " + JSON.stringify(cpts));
            
            // 2. IV PUSH - calcs[stype][infs[f].site][infs[f].drug.toLowerCase()].infs
            for(let iv=0; iv<ivplen; iv++){
                let drugs = Object.keys(calcs.ivpushs[ivpsites[iv]]), drugslen = drugs.length;
                for(let d=0; d<drugslen; d++){
                    // console.log("DRUG: " + drugs[d]);
                    let ivparr = Array.from(calcs.ivpushs[ivpsites[iv]][drugs[d]].infs),
                        ivps = ivparr.sort((prev, current) => (prev.startdt > current.startdt) ? 1 : -1);
                        //ivps = ivparr;
                    for (let s=0; s<ivps.length; s++){
                        if(d==0){
                            if(s==0 && !ivps[s].samedrug){
                                cpts.push({
                                    id: ulid(),
                                    code: "96374",
                                    qty: 1,
                                    department: ivps[s].department,
                                    site: ivpsites[iv],
                                    drug: ivps[s].drug,
                                    dos: ivps[s].dos,
                                    starttime: ivps[s].startdt,
                                    start:ivps[s].start,
                                    mods:this.overallMod()
                                });
                                for (let c=0; c<cpts.length; c++){
                                    if(cpts[c].code == "96360" && cpts[c].site == ivps[s].site){
                                        let create61 = true;
                                        let new61 = cpts.splice(c,1);
                                        // for (let cc=0; cc<cpts.length; cc++){
                                        //     if(cpts[cc].code == "96361" && cpts[cc].site == ivps[s].site){
                                        //         cpts[cc].qty += 1;
                                        //         create61 = false;
                                        //     }
                                        // }
                                        if(create61){
                                            let out = new61[0];
                                            out.code = "96361";
                                            cpts.push(out);
                                        }
                                    }
                                    
                                }
                            }else{
                                if(ivps[s-1]){
                                    let diff = Math.abs(ivps[s].startdt - ivps[s-1].startdt),
                                        tbtwn = Math.floor((diff/1000)/60);
                                    if(tbtwn > 29){
                                        cpts.push({
                                            id: ulid(),
                                            code: "96376",
                                            qty: 1,
                                            department: ivps[s].department,
                                            site: ivpsites[iv],
                                            drug: ivps[s].drug,
                                            dos: ivps[s].dos,
                                            starttime: ivps[s].startdt,
                                            start:ivps[s].start,
                                            mods:this.overallMod()
                                        });
                                    }else{
                                        cpts.push({
                                            id: ulid(),
                                            code: "SAME DRUG NOT 30 APART",
                                            nocharge:true,
                                            qty: 1,
                                            department: ivps[s].department,
                                            site: ivps[s].site,
                                            drug: ivps[s].drug,
                                            dos: ivps[s].dos,
                                            starttime: ivps[s].startdt,
                                            start: ivps[s].start,
                                            mods:[]
                                        });
                                    }
                                }else{
                                    cpts.push({
                                        id: ulid(),
                                        code: "96376",
                                        qty: 1,
                                        department: ivps[s].department,
                                        site: ivpsites[iv],
                                        drug: ivps[s].drug,
                                        dos: ivps[s].dos,
                                        starttime: ivps[s].startdt,
                                        start:ivps[s].start,
                                        mods:this.overallMod()
                                    });
                                }
                            }
                        }else{
                            if(s==0 && !ivps[s].samedrug){
                                cpts.push({
                                    id: ulid(),
                                    code: "96375",
                                    qty: 1,
                                    department: ivps[s].department,
                                    site: ivpsites[iv],
                                    drug: ivps[s].drug,
                                    dos: ivps[s].dos,
                                    starttime: ivps[s].startdt,
                                    start:ivps[s].start,
                                    mods:this.overallMod()
                                });
                            }else{
                                if(ivps[s-1]){
                                    let diff = Math.abs(ivps[s].startdt - ivps[s-1].startdt),
                                        tbtwn = Math.floor((diff/1000)/60);
                                    if(tbtwn > 29){
                                        cpts.push({
                                            id: ulid(),
                                            code: "96376",
                                            qty: 1,
                                            department: ivps[s].department,
                                            site: ivpsites[iv],
                                            drug: ivps[s].drug,
                                            dos: ivps[s].dos,
                                            starttime: ivps[s].startdt,
                                            start:ivps[s].start,
                                            mods:this.overallMod()
                                        });
                                    }else{
                                        cpts.push({
                                            id: ulid(),
                                            code: "SAME DRUG NOT 30 APART",
                                            nocharge:true,
                                            qty: 1,
                                            department: ivps[s].department,
                                            site: ivps[s].site,
                                            drug: ivps[s].drug,
                                            dos: ivps[s].dos,
                                            starttime: ivps[s].startdt,
                                            start:ivps[s].start,
                                            mods:[]
                                        });
                                    }
                                }else{
                                    cpts.push({
                                        id: ulid(),
                                        code: "96376",
                                        qty: 1,
                                        department: ivps[s].department,
                                        site: ivpsites[iv],
                                        drug: ivps[s].drug,
                                        dos: ivps[s].dos,
                                        starttime: ivps[s].startdt,
                                        start:ivps[s].start,
                                        mods:this.overallMod()
                                    });
                                }
                            }
                        }
                    }
                }                
            }
            // console.log("IVP CPTS: " + JSON.stringify(cpts));

            // 3. IV INFUSIONS - calcs[stype][infs[f].site][infs[f].drug.toLowerCase()].inf/tduration 
                 // calcs.ivinfs[ivisites[iv]][drugs[d]].infs
            for(let iv=0; iv<ivilen; iv++){
                // console.log("CHECKING INFUSIONS")
                let found67=[], firstDowncoded = false, 
                    drugs = Object.keys(calcs.ivinfs[ivisites[iv]]), drugslen = drugs.length;
                for(let d=0; d<drugslen; d++){
                    // console.log("DRUG: " + (d+1) + ": " + drugs[d] + " = " + calcs.ivinfs[ivisites[iv]][drugs[d]].tduration);
                    // DOWNCODE IF NO STOP OR LESS THAN 15
                    if(calcs.ivinfs[ivisites[iv]][drugs[d]].tduration == "NOSTOP" || calcs.ivinfs[ivisites[iv]][drugs[d]].tduration < 16){
                        // console.log("DOWNCODING INFUSION!");
                        if(d==0){
                            firstDowncoded = true;
                        }
                        let exist65 = false;
                        for (let c=0; c<cpts.length; c++){
                            // Upgrade existing 74's if they exists
                            if(cpts[c].code == "96374" && cpts[c].site == calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].site){
                                let new75 = cpts.splice(c,1);
                                let out = new75[0];
                                out.code = "96375";
                                cpts.push(out);
                            }
                            // Otherwise upgrade existing 60's if they exist
                            else if(cpts[c].code == "96360" && cpts[c].site == calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].site){
                                let create61 = true;
                                let new61 = cpts.splice(c,1);
                                // for (let cc=0; cc<cpts.length; cc++){
                                //     if(cpts[cc].code == "96361" && cpts[cc].site == calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].site){
                                //         cpts[cc].qty += 1;
                                //         create61 = false;
                                //     }
                                // }
                                if(create61){
                                    let out = new61[0];
                                    out.code = "96361";
                                    cpts.push(out);
                                }
                            }
                            // OTHERWISE check if a 65 exists to upgrade to a 75
                            else if(cpts[c].code == "96365" && cpts[c].site == calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].site){
                                exist65 = true;
                            }
                        }
                        cpts.push({
                            id: ulid(),
                            code: (exist65 ? "96375" : "96374"),
                            downcode:true,
                            qty: 1,
                            department: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].department,
                            site: ivisites[iv],
                            drug: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].drug,
                            dos: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].dos,
                            starttime: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].startdt,
                            start: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].start,
                            mods:this.overallMod()
                        });
                    }else if(d==0 || firstDowncoded){
                        // console.log("FIRST DRUG");
                        firstDowncoded = false;
                        if(calcs.ivinfs[ivisites[iv]][drugs[d]].tduration
                        >15){
                            cpts.push({
                                id: ulid(),
                                code: "96365",
                                qty: 1,
                                department: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].department,
                                site: ivisites[iv],
                                drug: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].drug,
                                dos: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].dos,
                                starttime: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].startdt,
                                start:calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].start,
                                mods:this.overallMod()
                            });
                            for (let c=0; c<cpts.length; c++){
                                if(cpts[c].code == "96360" && cpts[c].site == ivisites[iv]){
                                    let create61 = true;
                                    let new61 = cpts.splice(c,1);
                                    // for (let cc=0; cc<cpts.length; cc++){
                                    //     if(cpts[cc].code == "96361" && cpts[cc].site == ivisites[iv]){
                                    //         cpts[cc].qty += 1;
                                    //         create61 = false;
                                    //     }
                                    // }
                                    if(create61){
                                        let out = new61[0];
                                        out.code = "96361";
                                        cpts.push(out);
                                    }
                                }else if(cpts[c].code == "96374" && cpts[c].site == ivisites[iv]){
                                    let create75 = true;
                                    let new75 = cpts.splice(c,1);
                                    // for (let cc=0; cc<cpts.length; cc++){
                                    //     if(cpts[cc].code == "96375" && cpts[cc].site == ivisites[iv]){
                                    //         cpts[cc].qty += 1;
                                    //         create75 = false;
                                    //     }
                                    // }
                                    if(create75){
                                        let out = new75[0];
                                        out.code = "96375";
                                        cpts.push(out);
                                    }
                                }
                                
                            }
                            if(this.facSettings.ini_settings.repeat_med_rule){
                                // console.log("RMR INF");
                                let rmrLength = calcs.ivinfs[ivisites[iv]][drugs[d]].infs.length;
                                for (let rmr=0; rmr<rmrLength; rmr++){
                                    let hours = 0, qty = 0;
                                    if(rmr==0){
                                        calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration-=61;
                                        hours = (calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration)/60;
                                        //qty = Math.round((hours<0.5 && hours>0 ? 1 : hours));
                                        qty = Math.round(hours);
                                    }else{
                                        if(calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration>30){
                                            calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration-=30;
                                            hours = (calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration)/60;
                                            qty = Math.ceil(hours);
                                        }else if(calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration>0){
                                            qty = 1;
                                        }
                                        //qty = Math.round((hours<0.5 && hours>0 ? 1 : hours));
                                        //qty = Math.round(hours);
                                    };
                                    // console.log(hours + " | " + qty);
                                    if(qty>0){
                                        cpts.push({
                                            id: ulid(),
                                            code: "96366",
                                            // qty: Math.ceil((calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration)/60),
                                            qty: qty,
                                            department: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].department,
                                            site: ivisites[iv],
                                            drug: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].drug,
                                            dos: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].dos,
                                            starttime: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].startdt,
                                            start:calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].start,
                                            mods:this.overallMod()
                                        });
                                    }
                                }
                            }else if(calcs.ivinfs[ivisites[iv]][drugs[d]].tduration>90){
                                //if(!this.facSettings.ini_settings.ro_department){
                                if(false){
                                    // SEE HYDRATIONS FOR FIX TO DEPT DISPLAY
                                    // console.log("DEPT INF");
                                    let drugdur = calcs.ivinfs[ivisites[iv]][drugs[d]].tduration-90;
                                    // console.log(drugdur);
                                    for (let inf=1; inf<calcs.ivinfs[ivisites[iv]][drugs[d]].infs.length; inf++){
                                        // console.log(drugdur)
                                        if(drugdur>59){
                                            cpts.push({
                                                id: ulid(),
                                                code: "96366",
                                                qty: 1,
                                                department: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[inf].department,
                                                site: ivisites[iv],
                                                drug: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[inf].drug,
                                                dos: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[inf].dos,
                                                starttime: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[inf].startdt,
                                                start:calcs.ivinfs[ivisites[iv]][drugs[d]].infs[inf].start,
                                                mods:this.overallMod()
                                            });
                                            drugdur -= calcs.ivinfs[ivisites[iv]][drugs[d]].infs[inf].duration;
                                        }
                                        // console.log(drugdur);
                                    }
                                }else{
                                    // console.log("NOMRAL INF");
                                    cpts.push({
                                        id: ulid(),
                                        code: "96366",
                                        qty: Math.ceil((calcs.ivinfs[ivisites[iv]][drugs[d]].tduration-90)/60),
                                        department: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].department,
                                        site: ivisites[iv],
                                        drug: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].drug,
                                        dos: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].dos,
                                        starttime: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].startdt,
                                        start:calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].start,
                                        mods:this.overallMod()
                                    });
                                }
                            }
                        }
                    }else{
                        // FIRST CHECK FOR 96368 CONCURRENCY
                        let conc = false;
                        // console.log("HAVE A 68? " + this.found68);
                        // console.log("68 DOSs: " + JSON.stringify(this.found68dos));
                        // if(!this.found68 || (this.found68 && !this.found68dos.includes(calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].dos))){
                            // console.log("CHECKING FOR CONCURRENCY");
                            let iviarr = Array.from(calcs.ivinfs[ivisites[iv]][drugs[d]].infs),
                                ivis = iviarr.sort((prev, current) => (prev.startdt > current.startdt) ? -1 : 1);
                            for (let s=0; s<ivis.length; s++){
                                let found = false;
                                if(!this.found68 || (this.found68 && !this.found68dos.includes(ivis[s].dos))){
                                    for(let dd=0; dd<drugslen; dd++){
                                        let found2 = false;
                                        if(d != dd){
                                            let iviarr2 = Array.from(calcs.ivinfs[ivisites[iv]][drugs[dd]].infs),
                                                ivis2 = iviarr2.sort((prev, current) => (prev.startdt > current.startdt) ? -1 : 1);
                                            for (let ss=0; ss<ivis2.length; ss++){
                                                // console.log("FINAL CONC CHECK | " + ivis[s].drug + " - " + ivis[s].dos + " - " + ivis[s].start + ": " + ivis2[ss].startdt + " =< " + ivis[s].startdt + " < " + ivis2[ss].stopdt);
                                                if(ivis[s].startdt >= ivis2[ss].startdt && ivis[s].startdt < ivis2[ss].stopdt){
                                                    cpts.push({
                                                        id: ulid(),
                                                        code: "96368",
                                                        qty: 1,
                                                        department: ivis[s].department,
                                                        site: ivis[s].site,
                                                        drug: ivis[s].drug,
                                                        dos: ivis[s].dos,
                                                        starttime: ivis[s].startdt,
                                                        start:ivis[s].start,
                                                        mods:this.overallMod()
                                                    });
                                                    ivis[s].found68 = true;
                                                    found2=true;
                                                    conc=true;
                                                    this.found68=true;
                                                    this.found68dos.push(ivis[s].dos);
                                                    // console.log("FOUND A 68! BREAK 1");
                                                    // console.log(ivis[s].drug + " - " + ivis[s].dos + " - " + ivis[s].start + " MATCHES: " +ivis2[ss].drug + " - " + ivis2[ss].dos + " - " + ivis2[ss].start)
                                                    break;
                                                }
                                            }
                                        }
                                        if(found2){
                                            found=true;
                                            // console.log("BREAK 2");
                                            break;
                                        }
                                    }
                                }else{
                                    // console.log("QUICK BREAK");
                                    //break;
                                }
                                // if(found){
                                //     // console.log("FINAL BREAK");
                                //     break;
                                // }
                            }
                        //}
                        if(!conc){
                            let calc67 = true;
                            // console.log("67s: " + JSON.stringify(found67));
                            if(found67.length>0){
                                for(let f67=0; f67<found67.length; f67++){
                                    if(calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].startdt>=found67[f67].startdt && calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].startdt<=found67[f67].stopdt){
                                        calc67 = false;
                                        break;
                                    }
                                }
                            }
                            if(calcs.ivinfs[ivisites[iv]][drugs[d]].tduration>15 && calc67){
                                cpts.push({
                                    id: ulid(),
                                    code: "96367",
                                    qty: 1,
                                    department: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].department,
                                    site: ivisites[iv],
                                    drug: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].drug,
                                    dos: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].dos,
                                    starttime: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].startdt,
                                    start:calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].start,
                                    mods:this.overallMod()
                                });
                                found67.push({
                                    startdt: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].startdt,
                                    stopdt: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].stopdt
                                })
                            }
                        }
                        if(this.facSettings.ini_settings.repeat_med_rule){
                            // console.log("RMR INF");
                            let rmrLength = calcs.ivinfs[ivisites[iv]][drugs[d]].infs.length;
                            for (let rmr=0; rmr<rmrLength; rmr++){
                                if(!calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].found68){
                                    let hours = 0,qty =0;
                                    if(rmr==0){
                                        calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration-=61;
                                        hours = (calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration)/60;
                                        //qty = Math.round((hours<0.5 && hours>0 ? 1 : hours));
                                            qty = Math.round(hours);
                                    }else{
                                        hours = (calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration)/60;
                                        //qty = Math.ceil(hours);
                                            qty = Math.round((hours<0.5 && hours>0 ? 1 : hours));
                                            //qty = Math.round(hours);
                                    };
                                    // console.log(hours + " | " + qty);
                                    if(qty>0){
                                        cpts.push({
                                            id: ulid(),
                                            code: "96366",
                                            // qty: Math.ceil((calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].duration)/60),
                                            qty: qty,
                                            department: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].department,
                                            site: ivisites[iv],
                                            drug: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].drug,
                                            dos: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].dos,
                                            starttime: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].startdt,
                                            start:calcs.ivinfs[ivisites[iv]][drugs[d]].infs[rmr].start,
                                            mods:this.overallMod()
                                        });
                                    }
                                }
                            }
                        }else if(calcs.ivinfs[ivisites[iv]][drugs[d]].tduration>90){
                            cpts.push({
                                id: ulid(),
                                code: "96366",
                                qty: Math.ceil((calcs.ivinfs[ivisites[iv]][drugs[d]].tduration-90)/60),
                                department: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].department,
                                site: ivisites[iv],
                                drug: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].drug,
                                dos: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].dos,
                                starttime: calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].startdt,
                                start:calcs.ivinfs[ivisites[iv]][drugs[d]].infs[0].start,
                                mods:this.overallMod()
                            });
                        }
                    }              
                }                
            }
            // console.log("INF CPTS: " + JSON.stringify(cpts));

            // 4. CHEMO INFUSIONS - calcs[stype][infs[f].site][infs[f].drug.toLowerCase()].inf/tduration 
                 // calcs.chemos[ivisites[iv]][drugs[d]].infs
            for(let ch=0; ch<chilen; ch++){
                let drugs = this.sortInfObj(calcs.chemos[chisites[ch]]),
                    // drugs = Object.keys(calcs.chemos[chisites[ch]]), 
                    drugslen = drugs.length;
                for(let d=0; d<drugslen; d++){
                    // console.log("DRUG: " + (d+1) + ": " + drugs[d]);
                    // DOWNCODE IF NO STOP OR LESS THAN 15
                    if(calcs.chemos[chisites[ch]][drugs[d]].tduration == "NOSTOP"){
                        let exist65 = false;
                        for (let c=0; c<cpts.length; c++){
                            // Upgrade existing 74's if they exists
                            if(cpts[c].code == "96374" && cpts[c].site == calcs.chemos[chisites[ch]][drugs[d]].infs[0].site){
                                let new75 = cpts.splice(c,1);
                                let out = new75[0];
                                out.code = "96375";
                                cpts.push(out);
                            }
                            // Otherwise upgrade existing 60's if they exist
                            else if(cpts[c].code == "96360" && cpts[c].site == calcs.chemos[chisites[ch]][drugs[d]].infs[0].site){
                                let create61 = true;
                                let new61 = cpts.splice(c,1);
                                for (let cc=0; cc<cpts.length; cc++){
                                    if(cpts[cc].code == "96361" && cpts[cc].site == calcs.chemos[chisites[ch]][drugs[d]].infs[0].site){
                                        cpts[cc].qty += 1;
                                        create61 = false;
                                    }
                                }
                                if(create61){
                                    let out = new61[0];
                                    out.code = "96361";
                                    cpts.push(out);
                                }
                            }
                            // OTHERWISE check if a 65 exists to downcode to a 74/75
                            else if(cpts[c].code == "96365" && cpts[c].site == calcs.chemos[chisites[ch]][drugs[d]].infs[0].site){
                                exist65 = true;
                            }
                        }
                        cpts.push({
                            id: ulid(),
                            code: (exist65 ? "96375" : "96374"),
                            downcode:true,
                            qty: 1,
                            department: calcs.chemos[chisites[ch]][drugs[d]].infs[0].department,
                            site: chisites[ch],
                            drug: calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug,
                            dos: calcs.chemos[chisites[ch]][drugs[d]].infs[0].dos,
                            starttime: calcs.chemos[chisites[ch]][drugs[d]].infs[0].startdt,
                            start: calcs.chemos[chisites[ch]][drugs[d]].infs[0].start,
                            mods:this.overallMod()
                        });
                    }else if(chisites[ch].toLowerCase().includes("device")){
                        if(calcs.chemos[chisites[ch]][drugs[d]].tduration>479){
                            cpts.push({
                                id: ulid(),
                                code: "96416",
                                qty: 1,
                                department: calcs.chemos[chisites[ch]][drugs[d]].infs[0].department,
                                site: chisites[ch],
                                drug: calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug,
                                dos: calcs.chemos[chisites[ch]][drugs[d]].infs[0].dos,
                                starttime: calcs.chemos[chisites[ch]][drugs[d]].infs[0].startdt,
                                start:calcs.chemos[chisites[ch]][drugs[d]].infs[0].start,
                                mods:this.overallMod()
                            });
                        }else{
                            // console.log(calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug + " ON SITE " + chisites[ch] + " LESS THAN 8 HOURS IGNORE!");
                        }
                    }else if(chisites[ch].toLowerCase().includes("arterial")){
                        if(calcs.chemos[chisites[ch]][drugs[d]].tduration>15){
                            cpts.push({
                                id: ulid(),
                                code: "96422",
                                qty: 1,
                                department: calcs.chemos[chisites[ch]][drugs[d]].infs[0].department,
                                site: chisites[ch],
                                drug: calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug,
                                dos: calcs.chemos[chisites[ch]][drugs[d]].infs[0].dos,
                                starttime: calcs.chemos[chisites[ch]][drugs[d]].infs[0].startdt,
                                start:calcs.chemos[chisites[ch]][drugs[d]].infs[0].start,
                                mods:this.overallMod()
                            });
                            if(calcs.chemos[chisites[ch]][drugs[d]].tduration>90){
                                let qtyRaw = Math.ceil((calcs.chemos[chisites[ch]][drugs[d]].tduration-90)/60),
                                    qty = (qtyRaw > 8 ? 8 : qtyRaw);
                                cpts.push({
                                    id: ulid(),
                                    code: "96423",
                                    qty: qty,
                                    department: calcs.chemos[chisites[ch]][drugs[d]].infs[0].department,
                                    site: chisites[ch],
                                    drug: calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug,
                                    dos: calcs.chemos[chisites[ch]][drugs[d]].infs[0].dos,
                                    starttime: calcs.chemos[chisites[ch]][drugs[d]].infs[0].startdt,
                                    start:calcs.chemos[chisites[ch]][drugs[d]].infs[0].start,
                                    mods:this.overallMod()
                                });
                            }
                        }else{
                            cpts.push({
                                id: ulid(),
                                code: "96420",
                                qty: 1,
                                department: calcs.chemos[chisites[ch]][drugs[d]].infs[0].department,
                                site: chisites[ch],
                                drug: calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug,
                                dos: calcs.chemos[chisites[ch]][drugs[d]].infs[0].dos,
                                starttime: calcs.chemos[chisites[ch]][drugs[d]].infs[0].startdt,
                                start:calcs.chemos[chisites[ch]][drugs[d]].infs[0].start,
                                mods:this.overallMod()
                            });
                        }
                    }else if(d==0 && !calcs.chemos[chisites[ch]][drugs[d]].multidrug){
                        if(calcs.chemos[chisites[ch]][drugs[d]].tduration>15){
                            cpts.push({
                                id: ulid(),
                                code: "96413",
                                qty: 1,
                                department: calcs.chemos[chisites[ch]][drugs[d]].infs[0].department,
                                site: chisites[ch],
                                drug: calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug,
                                dos: calcs.chemos[chisites[ch]][drugs[d]].infs[0].dos,
                                starttime: calcs.chemos[chisites[ch]][drugs[d]].infs[0].startdt,
                                start:calcs.chemos[chisites[ch]][drugs[d]].infs[0].start,
                                mods:this.overallMod()
                            });
                            for (let c=0; c<cpts.length; c++){
                                if(cpts[c].code == "96360" && cpts[c].site == chisites[ch]){
                                    let create61 = true;
                                    let new61 = cpts.splice(c,1);
                                    for (let cc=0; cc<cpts.length; cc++){
                                        if(cpts[cc].code == "96361" && cpts[cc].site == chisites[ch]){
                                            cpts[cc].qty += 1;
                                            create61 = false;
                                        }
                                    }
                                    if(create61){
                                        let out = new61[0];
                                        out.code = "96361";
                                        cpts.push(out);
                                    }
                                }else if(cpts[c].code == "96374" && cpts[c].site == chisites[ch]){
                                    let create75 = true;
                                    let new75 = cpts.splice(c,1);
                                    // for (let cc=0; cc<cpts.length; cc++){
                                    //     if(cpts[cc].code == "96375" && cpts[cc].site == chisites[ch]){
                                    //         cpts[cc].qty += 1;
                                    //         create75 = false;
                                    //     }
                                    // }
                                    if(create75){
                                        let out = new75[0];
                                        out.code = "96375";
                                        cpts.push(out);
                                    }
                                }else if(cpts[c].code == "96365" && cpts[c].site == chisites[ch]){
                                    let create67 = true;
                                    let new67 = cpts.splice(c,1);
                                    // for (let cc=0; cc<cpts.length; cc++){
                                    //     if(cpts[cc].code == "96366" && cpts[cc].site == chisites[ch]){
                                    //         cpts[cc].qty += 1;
                                    //         create66 = false;
                                    //     }
                                    // }
                                    if(create67){
                                        let out = new67[0];
                                        out.code = "96367";
                                        cpts.push(out);
                                    }
                                }
                                
                            }
                            if(calcs.chemos[chisites[ch]][drugs[d]].tduration>90){
                                cpts.push({
                                    id: ulid(),
                                    code: "96415",
                                    qty: Math.ceil((calcs.chemos[chisites[ch]][drugs[d]].tduration-90)/60),
                                    department: calcs.chemos[chisites[ch]][drugs[d]].infs[0].department,
                                    site: chisites[ch],
                                    drug: calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug,
                                    dos: calcs.chemos[chisites[ch]][drugs[d]].infs[0].dos,
                                    starttime: calcs.chemos[chisites[ch]][drugs[d]].infs[0].startdt,
                                    start:calcs.chemos[chisites[ch]][drugs[d]].infs[0].start,
                                    mods:this.overallMod()
                                });
                            }
                        }else{
                            cpts.push({
                                id: ulid(),
                                code: "96409",
                                qty: 1,
                                department: calcs.chemos[chisites[ch]][drugs[d]].infs[0].department,
                                site: chisites[ch],
                                drug: calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug,
                                dos: calcs.chemos[chisites[ch]][drugs[d]].infs[0].dos,
                                starttime: calcs.chemos[chisites[ch]][drugs[d]].infs[0].startdt,
                                start:calcs.chemos[chisites[ch]][drugs[d]].infs[0].start,
                                mods:this.overallMod()
                            });
                        }
                    }else{
                        if(calcs.chemos[chisites[ch]][drugs[d]].tduration>15){
                            cpts.push({
                                id: ulid(),
                                code: "96417",
                                qty: 1,
                                department: calcs.chemos[chisites[ch]][drugs[d]].infs[0].department,
                                site: chisites[ch],
                                drug: calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug,
                                dos: calcs.chemos[chisites[ch]][drugs[d]].infs[0].dos,
                                starttime: calcs.chemos[chisites[ch]][drugs[d]].infs[0].startdt,
                                start:calcs.chemos[chisites[ch]][drugs[d]].infs[0].start,
                                mods:this.overallMod()
                            });
                        }else{
                            cpts.push({
                                id: ulid(),
                                code: "96411",
                                qty: 1,
                                department: calcs.chemos[chisites[ch]][drugs[d]].infs[0].department,
                                site: chisites[ch],
                                drug: calcs.chemos[chisites[ch]][drugs[d]].infs[0].drug,
                                dos: calcs.chemos[chisites[ch]][drugs[d]].infs[0].dos,
                                starttime: calcs.chemos[chisites[ch]][drugs[d]].infs[0].startdt,
                                start:calcs.chemos[chisites[ch]][drugs[d]].infs[0].start,
                                mods:this.overallMod()
                            });
                        }
                    }              
                }                
            }
            // console.log("CHEMO " + JSON.stringify(cpts));

            // ADD SAME CPTS BACK TOGETHER IF IN SAME DEPARTMENT SITE AND DRUG
            // for(let c=this.iniCDIs.length-1; c>=0; c--){
            if(this.facSettings.ini_settings.ro_department){
                for (let c=cpts.length-1; c>=0; c--){
                    let rems = [];
                    for (let cc=cpts.length; cc>=0; cc--){
                        if(c != cc && cpts[c] && cpts[cc] && cpts[c].code == cpts[cc].code && cpts[c].department == cpts[cc].department && cpts[c].site == cpts[cc].site && cpts[c].drug == cpts[cc].drug && cpts[c].dos == cpts[cc].dos){
                            // console.log(cpts[c].code);
                            // console.log(cpts[cc].code);
                            cpts[c].qty += cpts[cc].qty;
                            rems.push(cc);
                        }
                    }
                    for (let r=0; r<rems.length; r++){
                        cpts.splice(rems[r],1);
                    }
                }
            }else{
                for (let c=cpts.length-1; c>=0; c--){
                    let rems = [];
                    for (let cc=cpts.length; cc>=0; cc--){
                        if(c != cc && cpts[c] && cpts[cc] && cpts[c].code == cpts[cc].code && cpts[c].department == cpts[cc].department && cpts[c].site == cpts[cc].site && cpts[c].drug == cpts[cc].drug && cpts[c].starttime == cpts[cc].starttime){
                            // console.log(cpts[c].code);
                            // console.log(cpts[cc].code);
                            cpts[c].qty += cpts[cc].qty;
                            rems.push(cc);
                        }
                    }
                    for (let r=0; r<rems.length; r++){
                        cpts.splice(rems[r],1);
                    }
                }
            }
            // SIMPLE SORT BY CODE ASCENDING...COULD INCLUDE TYPE FOR BETTER
            cpts.sort((prev, current) => (prev.code > current.code) ? 1 : -1);
            // console.log("FIXED RES? " + fixres);
            // console.log("CALC OUT: " + JSON.stringify(cpts,null,2));
            // cpts = this.sortResults(cpts);
            // console.log("CALC OUT2: " + JSON.stringify(cpts,null,2));

            if(fixres){
                this.iniVal.fixed_results = cpts;
            }else{
                this.iniVal.fixed_results = cpts;
                this.iniVal.results = cpts;
                if(noStopRun){
                    this.difRes = true;
                    this.iniCalc(viewonly,true);
                }else{
                    this.difRes = false;
                }
            }            
        },
        sortInfObj(obj){
            let keys = Object.keys(obj),
                wkg=[], out = [];
            for (let i=0; i<keys.length; i++){
                wkg.push({
                    name: keys[i],
                    time: obj[keys[i]].tduration
                });
            }
            wkg.sort((prev, current) => (prev.time > current.time) ? -1 : 1);
            for (let w=0; w<wkg.length; w++){
                out.push(wkg[w].name);
            }
            return out;
        },
        allCapArray(arr){
            // console.log("IN: " + JSON.stringify(arr));
            for(let a=0; a<arr.length; a++){
                arr[a] = arr[a].toString().toUpperCase().replace(/\s+/g, '');
                let ind = arr.indexOf(arr[a]);
                // console.log("IND: " + ind);
                // console.log("A: " + a);
                if(ind != -1 && ind != a){
                    //arr.splice(a,1);
                    arr.splice(ind,1);
                }
            }
            let out = [...new Set(arr)]
            // console.log("OUT: " + JSON.stringify(out));
            return out;
        },
        forceFormValidate(form){
            // console.log("FORCE VALIDATE: " + form);
            this.$refs[form].validate();
        },
        getProviderDetail:function(uuid){
            if(uuid){
                let provDet = this.$store.getters.Providers.find(x => x.uuid == uuid);
                return provDet.displayName + " (" + uuid + ")";
            }else{
                return "";
            }
        },
        async postData(url = "", data = {}) {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data), // body data type must match "Content-Type" header
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        async getData(url = "") {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        calcAge(){
            // console.log("CALC AGE");
            this.menudob = false;
        },
        ageTator(dobin){
            // console.log("DOB IN: " + dobin);
            let out;
            if(dobin && dobin.includes("/")){
                let dobarr = dobin.split("/"),
                    dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else if(dobin && dobin.includes("-")){
                let dobarr = dobin.split("-"),
                    dob = new Date(dobarr[0],dobarr[1],dobarr[2]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else{
                out = null;
            }
            return out
        }
    }
  };
</script>

<style>
    .nextDay label{
        font-size: 14px;
        line-height: 14px !important;
        margin-left: -5px;
    }
    .theme--dark.v-tabs-items{
        background-color: unset;
    }
</style>